//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AdvantoApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    getStatus( cancelToken?: CancelToken): Promise<AdvantoStatusResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/advanto/get-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<AdvantoStatusResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvantoStatusResponseDTO.fromJS(resultData200);
            return Promise.resolve<AdvantoStatusResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvantoStatusResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    setStatus( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/advanto/set-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetStatus(_response);
        });
    }

    protected processSetStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return Created
     */
    applications(body: ApplicationCreateRequestDTO, cancelToken?: CancelToken): Promise<ApplicationCreateResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplications(_response);
        });
    }

    protected processApplications(response: AxiosResponse): Promise<ApplicationCreateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationCreateResponseDTO.fromJS(resultData200);
            return Promise.resolve<ApplicationCreateResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Language not exists", status, _responseText, _headers);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("Request is not allowed for now", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Don\'t created", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationCreateResponseDTO>(null as any);
    }

    /**
     * @return Created
     */
    stavar(body: ApplicationCreateRequestDTO, cancelToken?: CancelToken): Promise<ApplicationCreateResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/applications/stavar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStavar(_response);
        });
    }

    protected processStavar(response: AxiosResponse): Promise<ApplicationCreateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationCreateResponseDTO.fromJS(resultData200);
            return Promise.resolve<ApplicationCreateResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Language not exists", status, _responseText, _headers);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("Request is not allowed for now", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Don\'t created", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationCreateResponseDTO>(null as any);
    }

    /**
     * @return Success
     */
    partialRegistration(body: PartialRegistrationRequestDTO, cancelToken?: CancelToken): Promise<PartialRegistrationResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/applications/partial-registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPartialRegistration(_response);
        });
    }

    protected processPartialRegistration(response: AxiosResponse): Promise<PartialRegistrationResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PartialRegistrationResponseDTO.fromJS(resultData200);
            return Promise.resolve<PartialRegistrationResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("404", status, _responseText, _headers);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("429", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("500", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartialRegistrationResponseDTO>(null as any);
    }

    /**
     * @return Success
     */
    registerAndChooseModules(body: RegisterAndChooseModulesRequestDTO, cancelToken?: CancelToken): Promise<RegisterAndChooseModulesResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/applications/register-and-choose-modules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAndChooseModules(_response);
        });
    }

    protected processRegisterAndChooseModules(response: AxiosResponse): Promise<RegisterAndChooseModulesResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterAndChooseModulesResponseDTO.fromJS(resultData200);
            return Promise.resolve<RegisterAndChooseModulesResponseDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("404", status, _responseText, _headers);

        } else if (status === 429) {
            const _responseText = response.data;
            return throwException("429", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("500", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterAndChooseModulesResponseDTO>(null as any);
    }

    /**
     * @return App data copied
     */
    cloneAppData(body: CloneAppDataRequestDTO, cancelToken?: CancelToken): Promise<CloneAppDataResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/applications/clone-app-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneAppData(_response);
        });
    }

    protected processCloneAppData(response: AxiosResponse): Promise<CloneAppDataResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloneAppDataResponseDTO.fromJS(resultData200);
            return Promise.resolve<CloneAppDataResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloneAppDataResponseDTO>(null as any);
    }
}

export class AttendanceApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return Attendances
     */
    getAttendance(month: number, cancelToken?: CancelToken): Promise<GetAttendanceResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/attendance/get-attendance?";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAttendance(_response);
        });
    }

    protected processGetAttendance(response: AxiosResponse): Promise<GetAttendanceResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAttendanceResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetAttendanceResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAttendanceResponseDTO>(null as any);
    }
}

export class BOZPApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return All Bozps
     */
    getAllBozp( cancelToken?: CancelToken): Promise<GetAllBozpResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/bozp/get-all-bozp";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBozp(_response);
        });
    }

    protected processGetAllBozp(response: AxiosResponse): Promise<GetAllBozpResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllBozpResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetAllBozpResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllBozpResponseDTO>(null as any);
    }

    /**
     * @return User logged
     */
    setBozpAsRead(body: SetBozpAsReadRequestDTO, cancelToken?: CancelToken): Promise<SetBozpAsReadResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/bozp/set-bozp-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetBozpAsRead(_response);
        });
    }

    protected processSetBozpAsRead(response: AxiosResponse): Promise<SetBozpAsReadResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SetBozpAsReadResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SetBozpAsReadResponseDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetBozpAsReadResponseDTO[]>(null as any);
    }
}

export class BuildingDiaryApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return Diary printed
     */
    printWholeDiary(body: PrintWholeDiaryRequestDTO, cancelToken?: CancelToken): Promise<PrintWholeDiaryResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/building-diary/print-whole-diary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeDiary(_response);
        });
    }

    protected processPrintWholeDiary(response: AxiosResponse): Promise<PrintWholeDiaryResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrintWholeDiaryResponseDTO.fromJS(resultData200);
            return Promise.resolve<PrintWholeDiaryResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrintWholeDiaryResponseDTO>(null as any);
    }

    /**
     * @return Diary printed
     */
    printWholeDiaryInvestor(body: PrintWholeDiaryInvestorRequestDTO, cancelToken?: CancelToken): Promise<PrintWholeDiaryResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/building-diary/print-whole-diary-investor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeDiaryInvestor(_response);
        });
    }

    protected processPrintWholeDiaryInvestor(response: AxiosResponse): Promise<PrintWholeDiaryResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrintWholeDiaryResponseDTO.fromJS(resultData200);
            return Promise.resolve<PrintWholeDiaryResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrintWholeDiaryResponseDTO>(null as any);
    }

    /**
     * @return Diary printed
     */
    printWholeDiaryInDateRange(body: PrintWholeDiaryInDateRangeRequestDTO, cancelToken?: CancelToken): Promise<PrintWholeDiaryResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/building-diary/print-whole-diary-in-date-range";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintWholeDiaryInDateRange(_response);
        });
    }

    protected processPrintWholeDiaryInDateRange(response: AxiosResponse): Promise<PrintWholeDiaryResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrintWholeDiaryResponseDTO.fromJS(resultData200);
            return Promise.resolve<PrintWholeDiaryResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrintWholeDiaryResponseDTO>(null as any);
    }
}

export class BuildingsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return All buildings
     */
    getAllBuildings( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/get-all-buildings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBuildings(_response);
        });
    }

    protected processGetAllBuildings(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Building
     */
    getBuildingById(buildingId: number, cancelToken?: CancelToken): Promise<BuildingResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/get-building-by-id?";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined and cannot be null.");
        else
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildingById(_response);
        });
    }

    protected processGetBuildingById(response: AxiosResponse): Promise<BuildingResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BuildingResponseDTO.fromJS(resultData200);
            return Promise.resolve<BuildingResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BuildingResponseDTO>(null as any);
    }

    /**
     * @return Employees
     */
    getEmployees(buildingId: number, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/get-employees?";
        if (buildingId === undefined || buildingId === null)
            throw new Error("The parameter 'buildingId' must be defined and cannot be null.");
        else
            url_ += "buildingId=" + encodeURIComponent("" + buildingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Images added
     */
    addImagesToBuilding(body: AddImagesRequestDTO, cancelToken?: CancelToken): Promise<AddImagesResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/buildings/add-images-to-building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddImagesToBuilding(_response);
        });
    }

    protected processAddImagesToBuilding(response: AxiosResponse): Promise<AddImagesResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddImagesResponseDTO.fromJS(resultData200);
            return Promise.resolve<AddImagesResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddImagesResponseDTO>(null as any);
    }
}

export class ButtonsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return All actions
     */
    getAllActions( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/buttons/get-all-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllActions(_response);
        });
    }

    protected processGetAllActions(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class CompactiveIntegrationApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return Employee info sent
     */
    getEmployee(body: GetEmployeeRequestDTO, cancelToken?: CancelToken): Promise<GetEmployeeResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/compactive-integration/get-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: AxiosResponse): Promise<GetEmployeeResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetEmployeeResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetEmployeeResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetEmployeeResponseDTO>(null as any);
    }

    /**
     * @return Records info sent
     */
    getRecords(body: GetRecordsRequestDTO, cancelToken?: CancelToken): Promise<GetRecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/compactive-integration/get-records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecords(_response);
        });
    }

    protected processGetRecords(response: AxiosResponse): Promise<GetRecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetRecordsResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRecordsResponseDTO>(null as any);
    }

    /**
     * @return Building info sent
     */
    getBuilding(body: GetBuildingRequestDTO, cancelToken?: CancelToken): Promise<GetBuildingResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/compactive-integration/get-building";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuilding(_response);
        });
    }

    protected processGetBuilding(response: AxiosResponse): Promise<GetBuildingResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBuildingResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetBuildingResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBuildingResponseDTO>(null as any);
    }
}

export class DocumentsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return All documents
     */
    getAllDocuments( cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/api_v2.7/documents/get-all-documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllDocuments(_response);
        });
    }

    protected processGetAllDocuments(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Documents
     */
    setDocumentAsRead(body: SetDocumentAsReadRequestDTO, cancelToken?: CancelToken): Promise<DocumentResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/documents/set-document-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDocumentAsRead(_response);
        });
    }

    protected processSetDocumentAsRead(response: AxiosResponse): Promise<DocumentResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentResponseDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponseDTO[]>(null as any);
    }

    /**
     * @return Documents
     */
    setDocumentAsRejected(body: SetDocumentAsRejectedRequestDTO, cancelToken?: CancelToken): Promise<DocumentResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/documents/set-document-as-rejected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDocumentAsRejected(_response);
        });
    }

    protected processSetDocumentAsRejected(response: AxiosResponse): Promise<DocumentResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentResponseDTO[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentResponseDTO[]>(null as any);
    }
}

export class EmployeesApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return Employee info
     */
    getInfo( cancelToken?: CancelToken): Promise<EmployeeInfoResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/employees/get-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInfo(_response);
        });
    }

    protected processGetInfo(response: AxiosResponse): Promise<EmployeeInfoResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeInfoResponseDTO.fromJS(resultData200);
            return Promise.resolve<EmployeeInfoResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeInfoResponseDTO>(null as any);
    }
}

export class AuthApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return FCM Token updated
     */
    fcmToken(body: FcmTokenRequestDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/fcm-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFcmToken(_response);
        });
    }

    protected processFcmToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized access", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return App key info
     */
    isAppKeyValid(appKey: string, cancelToken?: CancelToken): Promise<AppKeyResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/is-app-key-valid?";
        if (appKey === undefined || appKey === null)
            throw new Error("The parameter 'appKey' must be defined and cannot be null.");
        else
            url_ += "appKey=" + encodeURIComponent("" + appKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsAppKeyValid(_response);
        });
    }

    protected processIsAppKeyValid(response: AxiosResponse): Promise<AppKeyResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppKeyResponseDTO.fromJS(resultData200);
            return Promise.resolve<AppKeyResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized access", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppKeyResponseDTO>(null as any);
    }

    /**
     * @return Language changed
     */
    language(body: LanguageRequestDTO, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/language";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanguage(_response);
        });
    }

    protected processLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized access", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return User logged
     */
    login(body: LoginRequestDTO, cancelToken?: CancelToken): Promise<LoginResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResponseDTO.fromJS(resultData200);
            return Promise.resolve<LoginResponseDTO>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponseDTO>(null as any);
    }

    /**
     * @return User logged
     */
    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api_v2.7/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return success
     */
    requestNewPin(body: NewPinRequestDTO, cancelToken?: CancelToken): Promise<NewPinResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/request-new-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestNewPin(_response);
        });
    }

    protected processRequestNewPin(response: AxiosResponse): Promise<NewPinResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewPinResponseDTO.fromJS(resultData200);
            return Promise.resolve<NewPinResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewPinResponseDTO>(null as any);
    }
}

export class FilesApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return File meta
     */
    getFileMeta(filename: string, cancelToken?: CancelToken): Promise<FileMetadataResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/files/get-file-meta?";
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined and cannot be null.");
        else
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileMeta(_response);
        });
    }

    protected processGetFileMeta(response: AxiosResponse): Promise<FileMetadataResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FileMetadataResponseDTO.fromJS(resultData200);
            return Promise.resolve<FileMetadataResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileMetadataResponseDTO>(null as any);
    }

    /**
     * @return Files added
     */
    addFile(body: AddFileRequestDTO, cancelToken?: CancelToken): Promise<AddFileResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/files/add-file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFile(_response);
        });
    }

    protected processAddFile(response: AxiosResponse): Promise<AddFileResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddFileResponseDTO.fromJS(resultData200);
            return Promise.resolve<AddFileResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddFileResponseDTO>(null as any);
    }

    /**
     * @return Files added
     */
    addFileWithPassword(body: AddFileRequestDTO, cancelToken?: CancelToken): Promise<AddFileResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/files/add-file-with-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFileWithPassword(_response);
        });
    }

    protected processAddFileWithPassword(response: AxiosResponse): Promise<AddFileResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddFileResponseDTO.fromJS(resultData200);
            return Promise.resolve<AddFileResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddFileResponseDTO>(null as any);
    }

    /**
     * @return Files added
     */
    addFileInvestor(body: AddFileInvestorRequestDTO, cancelToken?: CancelToken): Promise<AddFileInvestorResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/files/add-file-investor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFileInvestor(_response);
        });
    }

    protected processAddFileInvestor(response: AxiosResponse): Promise<AddFileInvestorResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddFileInvestorResponseDTO.fromJS(resultData200);
            return Promise.resolve<AddFileInvestorResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddFileInvestorResponseDTO>(null as any);
    }
}

export class NewsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return News
     */
    getAllNews( cancelToken?: CancelToken): Promise<NewsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/news/get-all-news";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllNews(_response);
        });
    }

    protected processGetAllNews(response: AxiosResponse): Promise<NewsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsResponseDTO.fromJS(resultData200);
            return Promise.resolve<NewsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    setNewAsRead(body: NewRequestDTO, cancelToken?: CancelToken): Promise<NewSetResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/news/set-new-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetNewAsRead(_response);
        });
    }

    protected processSetNewAsRead(response: AxiosResponse): Promise<NewSetResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewSetResponseDTO.fromJS(resultData200);
            return Promise.resolve<NewSetResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewSetResponseDTO>(null as any);
    }
}

export class RecommendationsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    getAllRecommendations(adminUserId: number, token: string, cancelToken?: CancelToken): Promise<GetAllRecommendationsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/get-all-recommendations?";
        if (adminUserId === undefined || adminUserId === null)
            throw new Error("The parameter 'adminUserId' must be defined and cannot be null.");
        else
            url_ += "adminUserId=" + encodeURIComponent("" + adminUserId) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllRecommendations(_response);
        });
    }

    protected processGetAllRecommendations(response: AxiosResponse): Promise<GetAllRecommendationsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllRecommendationsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetAllRecommendationsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllRecommendationsResponseDTO>(null as any);
    }

    /**
     * @param body Pet object that needs to be added to the store
     * @return success
     */
    sendInvitations(body: SendInvitationsRequestDTO, cancelToken?: CancelToken): Promise<SendInvitationsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/send-invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInvitations(_response);
        });
    }

    protected processSendInvitations(response: AxiosResponse): Promise<SendInvitationsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendInvitationsResponseDTO.fromJS(resultData200);
            return Promise.resolve<SendInvitationsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendInvitationsResponseDTO>(null as any);
    }

    /**
     * @param body Create application from invitation
     * @return success
     */
    createApplicationFromInvite(body: CreateAppFromInviteRequestDTO, cancelToken?: CancelToken): Promise<ApplicationCreateResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/create-application-from-invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApplicationFromInvite(_response);
        });
    }

    protected processCreateApplicationFromInvite(response: AxiosResponse): Promise<ApplicationCreateResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationCreateResponseDTO.fromJS(resultData200);
            return Promise.resolve<ApplicationCreateResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationCreateResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    getDataForInvite(recommendationId: number, token: string, cancelToken?: CancelToken): Promise<GetDataForInviteResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/get-data-for-invite?";
        if (recommendationId === undefined || recommendationId === null)
            throw new Error("The parameter 'recommendationId' must be defined and cannot be null.");
        else
            url_ += "recommendationId=" + encodeURIComponent("" + recommendationId) + "&";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataForInvite(_response);
        });
    }

    protected processGetDataForInvite(response: AxiosResponse): Promise<GetDataForInviteResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDataForInviteResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetDataForInviteResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDataForInviteResponseDTO>(null as any);
    }

    /**
     * @param body Sending email to Stavario about rewardsn
     * @return success
     */
    sendEmailToStavario(body: SendEmailToStavarioRequestDTO, cancelToken?: CancelToken): Promise<SendEmailToStavarioResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/recommendations/send-email-to-stavario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailToStavario(_response);
        });
    }

    protected processSendEmailToStavario(response: AxiosResponse): Promise<SendEmailToStavarioResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendEmailToStavarioResponseDTO.fromJS(resultData200);
            return Promise.resolve<SendEmailToStavarioResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendEmailToStavarioResponseDTO>(null as any);
    }
}

export class RecordsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return Record
     */
    getLastRecord( cancelToken?: CancelToken): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/get-last-record";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastRecord(_response);
        });
    }

    protected processGetLastRecord(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return Record
     */
    getLastRecordWithFood( cancelToken?: CancelToken): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/get-last-record-with-food";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastRecordWithFood(_response);
        });
    }

    protected processGetLastRecordWithFood(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return Record
     */
    getLastRecordWithBreak( cancelToken?: CancelToken): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/get-last-record-with-break";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastRecordWithBreak(_response);
        });
    }

    protected processGetLastRecordWithBreak(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return Record
     */
    getCustomRecords( cancelToken?: CancelToken): Promise<GetCustomRecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/get-custom-records";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomRecords(_response);
        });
    }

    protected processGetCustomRecords(response: AxiosResponse): Promise<GetCustomRecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCustomRecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetCustomRecordsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCustomRecordsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    insertRecord(body: InsertRecordRequestDTO, cancelToken?: CancelToken): Promise<RecordsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertRecord(_response);
        });
    }

    protected processInsertRecord(response: AxiosResponse): Promise<RecordsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RecordsResponseDTO.fromJS(resultData200);
            return Promise.resolve<RecordsResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecordsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    insertBreak(body: InsertBreakRequestDTO, cancelToken?: CancelToken): Promise<InsertBreakResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-break";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertBreak(_response);
        });
    }

    protected processInsertBreak(response: AxiosResponse): Promise<InsertBreakResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertBreakResponseDTO.fromJS(resultData200);
            return Promise.resolve<InsertBreakResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertBreakResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    insertDoctor(body: InsertDoctorDTO, cancelToken?: CancelToken): Promise<InsertDoctorDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-doctor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertDoctor(_response);
        });
    }

    protected processInsertDoctor(response: AxiosResponse): Promise<InsertDoctorDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertDoctorDTO.fromJS(resultData200);
            return Promise.resolve<InsertDoctorDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertDoctorDTO>(null as any);
    }

    /**
     * @return success
     */
    insertHoliday(body: InsertHolidayDTO, cancelToken?: CancelToken): Promise<InsertHolidayDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-holiday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertHoliday(_response);
        });
    }

    protected processInsertHoliday(response: AxiosResponse): Promise<InsertHolidayDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertHolidayDTO.fromJS(resultData200);
            return Promise.resolve<InsertHolidayDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertHolidayDTO>(null as any);
    }

    /**
     * @return success
     */
    insertSick(body: InsertSickDTO, cancelToken?: CancelToken): Promise<InsertSickDTO> {
        let url_ = this.baseUrl + "/api_v2.7/records/insert-sick";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertSick(_response);
        });
    }

    protected processInsertSick(response: AxiosResponse): Promise<InsertSickDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertSickDTO.fromJS(resultData200);
            return Promise.resolve<InsertSickDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertSickDTO>(null as any);
    }
}

export class RequestsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    getRequests(state: number, limit: number, offset: number, cancelToken?: CancelToken): Promise<GetRequestsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-requests?";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined and cannot be null.");
        else
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        if (limit === undefined || limit === null)
            throw new Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === undefined || offset === null)
            throw new Error("The parameter 'offset' must be defined and cannot be null.");
        else
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequests(_response);
        });
    }

    protected processGetRequests(response: AxiosResponse): Promise<GetRequestsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetRequestsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetRequestsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetRequestsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    setRequestState(body: UpdateRequestStateDTO, cancelToken?: CancelToken): Promise<UpdateRequestStateDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/set-request-state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRequestState(_response);
        });
    }

    protected processSetRequestState(response: AxiosResponse): Promise<UpdateRequestStateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateRequestStateDTO.fromJS(resultData200);
            return Promise.resolve<UpdateRequestStateDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateRequestStateDTO>(null as any);
    }

    /**
     * @return success
     */
    insertRequest(body: InsertRequestDTO, cancelToken?: CancelToken): Promise<RequestResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/insert-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertRequest(_response);
        });
    }

    protected processInsertRequest(response: AxiosResponse): Promise<RequestResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RequestResponseDTO.fromJS(resultData200);
            return Promise.resolve<RequestResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Database problem", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestResponseDTO>(null as any);
    }

    /**
     * @param limit (optional) 
     * @param offset (optional) 
     * @return success
     */
    getMessages(requestId: number, limit: number | undefined, offset: number | undefined, cancelToken?: CancelToken): Promise<GetMessagesDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-messages?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: AxiosResponse): Promise<GetMessagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMessagesDTO.fromJS(resultData200);
            return Promise.resolve<GetMessagesDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMessagesDTO>(null as any);
    }

    /**
     * @param order (optional) 
     * @param limit (optional) 
     * @param from_id (optional) 
     * @return success
     */
    getMessagesPaginated(requestId: number, order: Order | undefined, limit: number | undefined, from_id: number | undefined, cancelToken?: CancelToken): Promise<GetMessagesDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-messages-paginated?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (order === null)
            throw new Error("The parameter 'order' cannot be null.");
        else if (order !== undefined)
            url_ += "order=" + encodeURIComponent("" + order) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (from_id === null)
            throw new Error("The parameter 'from_id' cannot be null.");
        else if (from_id !== undefined)
            url_ += "from_id=" + encodeURIComponent("" + from_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMessagesPaginated(_response);
        });
    }

    protected processGetMessagesPaginated(response: AxiosResponse): Promise<GetMessagesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMessagesDTO.fromJS(resultData200);
            return Promise.resolve<GetMessagesDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Request not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMessagesDTO>(null as any);
    }

    /**
     * @return success
     */
    insertMessage(body: InsertMessageRequestDTO, cancelToken?: CancelToken): Promise<InsertMessageResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/insert-message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsertMessage(_response);
        });
    }

    protected processInsertMessage(response: AxiosResponse): Promise<InsertMessageResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InsertMessageResponseDTO.fromJS(resultData200);
            return Promise.resolve<InsertMessageResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InsertMessageResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    setMessagesAsRead(body: SetMessagesAsReadDTO, cancelToken?: CancelToken): Promise<SetMessagesAsReadDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/set-messages-as-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMessagesAsRead(_response);
        });
    }

    protected processSetMessagesAsRead(response: AxiosResponse): Promise<SetMessagesAsReadDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetMessagesAsReadDTO.fromJS(resultData200);
            return Promise.resolve<SetMessagesAsReadDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetMessagesAsReadDTO>(null as any);
    }

    /**
     * @return success
     */
    getUnreadMessagesCount(requestId: number, cancelToken?: CancelToken): Promise<CountDTO> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-unread-messages-count?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnreadMessagesCount(_response);
        });
    }

    protected processGetUnreadMessagesCount(response: AxiosResponse): Promise<CountDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CountDTO.fromJS(resultData200);
            return Promise.resolve<CountDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountDTO>(null as any);
    }

    /**
     * @return success
     */
    getAssignee(requestId: number, cancelToken?: CancelToken): Promise<AssigneeChangeResponseDTO[]> {
        let url_ = this.baseUrl + "/api_v2.7/requests/get-assignee?";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined and cannot be null.");
        else
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignee(_response);
        });
    }

    protected processGetAssignee(response: AxiosResponse): Promise<AssigneeChangeResponseDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssigneeChangeResponseDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssigneeChangeResponseDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssigneeChangeResponseDTO[]>(null as any);
    }
}

export class SettingsApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    getSettings( cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api_v2.7/settings/get-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettings(_response);
        });
    }

    protected processGetSettings(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }
}

export class WealthApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    getEmployeesWealth( cancelToken?: CancelToken): Promise<GetWealthsResponseDTO> {
        let url_ = this.baseUrl + "/api_v2.7/wealth/get-employees-wealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeesWealth(_response);
        });
    }

    protected processGetEmployeesWealth(response: AxiosResponse): Promise<GetWealthsResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetWealthsResponseDTO.fromJS(resultData200);
            return Promise.resolve<GetWealthsResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetWealthsResponseDTO>(null as any);
    }

    /**
     * @return success
     */
    getWealthByCode(wealthCode: string, cancelToken?: CancelToken): Promise<WealthDTO> {
        let url_ = this.baseUrl + "/api_v2.7/wealth/get-wealth-by-code?";
        if (wealthCode === undefined || wealthCode === null)
            throw new Error("The parameter 'wealthCode' must be defined and cannot be null.");
        else
            url_ += "wealthCode=" + encodeURIComponent("" + wealthCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWealthByCode(_response);
        });
    }

    protected processGetWealthByCode(response: AxiosResponse): Promise<WealthDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WealthDTO.fromJS(resultData200);
            return Promise.resolve<WealthDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WealthDTO>(null as any);
    }

    /**
     * @return success
     */
    setWealthToEmployee(body: WealthUpdateRequestDTO, cancelToken?: CancelToken): Promise<WealthCodesDTO> {
        let url_ = this.baseUrl + "/api_v2.7/wealth/set-wealth-to-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetWealthToEmployee(_response);
        });
    }

    protected processSetWealthToEmployee(response: AxiosResponse): Promise<WealthCodesDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WealthCodesDTO.fromJS(resultData200);
            return Promise.resolve<WealthCodesDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad request", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WealthCodesDTO>(null as any);
    }
}

export class Integrations___AdvantoApiMobileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://default.vimovsem.cz";

    }

    /**
     * @return success
     */
    employees(employee_id: number, national_id: string, cancelToken?: CancelToken): Promise<AdvantoEmployeeDTO> {
        let url_ = this.baseUrl + "/integrations/advanto/employees/{employee_id}?";
        if (employee_id === undefined || employee_id === null)
            throw new Error("The parameter 'employee_id' must be defined.");
        url_ = url_.replace("{employee_id}", encodeURIComponent("" + employee_id));
        if (national_id === undefined || national_id === null)
            throw new Error("The parameter 'national_id' must be defined and cannot be null.");
        else
            url_ += "national_id=" + encodeURIComponent("" + national_id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmployees(_response);
        });
    }

    protected processEmployees(response: AxiosResponse): Promise<AdvantoEmployeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AdvantoEmployeeDTO.fromJS(resultData200);
            return Promise.resolve<AdvantoEmployeeDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvantoEmployeeDTO>(null as any);
    }

    /**
     * @return success
     */
    shifts(employee_id: number, from: string, to: string, cancelToken?: CancelToken): Promise<AdvantoShiftsDTO[]> {
        let url_ = this.baseUrl + "/integrations/advanto/shifts/{employee_id}?";
        if (employee_id === undefined || employee_id === null)
            throw new Error("The parameter 'employee_id' must be defined.");
        url_ = url_.replace("{employee_id}", encodeURIComponent("" + employee_id));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShifts(_response);
        });
    }

    protected processShifts(response: AxiosResponse): Promise<AdvantoShiftsDTO[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdvantoShiftsDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdvantoShiftsDTO[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdvantoShiftsDTO[]>(null as any);
    }
}

export class AdvantoStatusResponseDTO implements IAdvantoStatusResponseDTO {
    company?: AdvantoStatusResponseDTOCompany | undefined;
    employee?: AdvantoStatusResponseDTOEmployee | undefined;

    [key: string]: any;

    constructor(data?: IAdvantoStatusResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.company = _data["company"];
            this.employee = _data["employee"];
        }
    }

    static fromJS(data: any): AdvantoStatusResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvantoStatusResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["company"] = this.company;
        data["employee"] = this.employee;
        return data;
    }
}

export interface IAdvantoStatusResponseDTO {
    company?: AdvantoStatusResponseDTOCompany | undefined;
    employee?: AdvantoStatusResponseDTOEmployee | undefined;

    [key: string]: any;
}

export class ApplicationCreateRequestDTO implements IApplicationCreateRequestDTO {
    companyName!: string;
    email!: string;
    phonePrefix!: string;
    phoneNumber!: string;
    language!: string;
    source!: string;

    [key: string]: any;

    constructor(data?: IApplicationCreateRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.phonePrefix = _data["phonePrefix"];
            this.phoneNumber = _data["phoneNumber"];
            this.language = _data["language"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ApplicationCreateRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCreateRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["phonePrefix"] = this.phonePrefix;
        data["phoneNumber"] = this.phoneNumber;
        data["language"] = this.language;
        data["source"] = this.source;
        return data;
    }
}

export interface IApplicationCreateRequestDTO {
    companyName: string;
    email: string;
    phonePrefix: string;
    phoneNumber: string;
    language: string;
    source: string;

    [key: string]: any;
}

export class ApplicationCreateResponseDTO implements IApplicationCreateResponseDTO {
    url?: string;
    key?: string;

    [key: string]: any;

    constructor(data?: IApplicationCreateResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): ApplicationCreateResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationCreateResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        data["key"] = this.key;
        return data;
    }
}

export interface IApplicationCreateResponseDTO {
    url?: string;
    key?: string;

    [key: string]: any;
}

export class CloneAppDataRequestDTO implements ICloneAppDataRequestDTO {
    sourceAppId?: number;
    targetAppId?: number;

    [key: string]: any;

    constructor(data?: ICloneAppDataRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.sourceAppId = _data["sourceAppId"];
            this.targetAppId = _data["targetAppId"];
        }
    }

    static fromJS(data: any): CloneAppDataRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CloneAppDataRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["sourceAppId"] = this.sourceAppId;
        data["targetAppId"] = this.targetAppId;
        return data;
    }
}

export interface ICloneAppDataRequestDTO {
    sourceAppId?: number;
    targetAppId?: number;

    [key: string]: any;
}

export class CloneAppDataResponseDTO implements ICloneAppDataResponseDTO {
    ok?: boolean;
    error?: string;

    [key: string]: any;

    constructor(data?: ICloneAppDataResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ok = _data["ok"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CloneAppDataResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CloneAppDataResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ok"] = this.ok;
        data["error"] = this.error;
        return data;
    }
}

export interface ICloneAppDataResponseDTO {
    ok?: boolean;
    error?: string;

    [key: string]: any;
}

export class GetDisabledModulesResponseDTO implements IGetDisabledModulesResponseDTO {
    disabledModules?: string;

    [key: string]: any;

    constructor(data?: IGetDisabledModulesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.disabledModules = _data["disabledModules"];
        }
    }

    static fromJS(data: any): GetDisabledModulesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDisabledModulesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["disabledModules"] = this.disabledModules;
        return data;
    }
}

export interface IGetDisabledModulesResponseDTO {
    disabledModules?: string;

    [key: string]: any;
}

export class PartialRegistrationRequestDTO implements IPartialRegistrationRequestDTO {
    companyName!: string;
    email!: string;
    language!: string;
    source!: string;
    hasPricingPlan!: boolean;
    pricingPlan?: string;
    modules?: string;
    marketing_consent!: boolean;

    [key: string]: any;

    constructor(data?: IPartialRegistrationRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.language = _data["language"];
            this.source = _data["source"];
            this.hasPricingPlan = _data["hasPricingPlan"];
            this.pricingPlan = _data["pricingPlan"];
            this.modules = _data["modules"];
            this.marketing_consent = _data["marketing_consent"];
        }
    }

    static fromJS(data: any): PartialRegistrationRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartialRegistrationRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["language"] = this.language;
        data["source"] = this.source;
        data["hasPricingPlan"] = this.hasPricingPlan;
        data["pricingPlan"] = this.pricingPlan;
        data["modules"] = this.modules;
        data["marketing_consent"] = this.marketing_consent;
        return data;
    }
}

export interface IPartialRegistrationRequestDTO {
    companyName: string;
    email: string;
    language: string;
    source: string;
    hasPricingPlan: boolean;
    pricingPlan?: string;
    modules?: string;
    marketing_consent: boolean;

    [key: string]: any;
}

export class PartialRegistrationResponseDTO implements IPartialRegistrationResponseDTO {
    id?: number;
    error?: string;

    [key: string]: any;

    constructor(data?: IPartialRegistrationResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): PartialRegistrationResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PartialRegistrationResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["error"] = this.error;
        return data;
    }
}

export interface IPartialRegistrationResponseDTO {
    id?: number;
    error?: string;

    [key: string]: any;
}

export class RegisterAndChooseModulesRequestDTO implements IRegisterAndChooseModulesRequestDTO {
    pendingRegistrationId?: string;
    companyName!: string;
    email!: string;
    phonePrefix!: string;
    phoneNumber!: string;
    language!: string;
    source!: string;
    ico?: string;
    hasDiaryModule?: boolean;
    hasAttendanceModule?: boolean;
    hasTasksModule?: boolean;
    hasWealthModule?: boolean;
    hasWarehousesModule?: boolean;
    hasGanttModule?: boolean;
    hasAIModule?: boolean;
    hasReportsModule?: boolean;

    [key: string]: any;

    constructor(data?: IRegisterAndChooseModulesRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pendingRegistrationId = _data["pendingRegistrationId"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.phonePrefix = _data["phonePrefix"];
            this.phoneNumber = _data["phoneNumber"];
            this.language = _data["language"];
            this.source = _data["source"];
            this.ico = _data["ico"];
            this.hasDiaryModule = _data["hasDiaryModule"];
            this.hasAttendanceModule = _data["hasAttendanceModule"];
            this.hasTasksModule = _data["hasTasksModule"];
            this.hasWealthModule = _data["hasWealthModule"];
            this.hasWarehousesModule = _data["hasWarehousesModule"];
            this.hasGanttModule = _data["hasGanttModule"];
            this.hasAIModule = _data["hasAIModule"];
            this.hasReportsModule = _data["hasReportsModule"];
        }
    }

    static fromJS(data: any): RegisterAndChooseModulesRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAndChooseModulesRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pendingRegistrationId"] = this.pendingRegistrationId;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["phonePrefix"] = this.phonePrefix;
        data["phoneNumber"] = this.phoneNumber;
        data["language"] = this.language;
        data["source"] = this.source;
        data["ico"] = this.ico;
        data["hasDiaryModule"] = this.hasDiaryModule;
        data["hasAttendanceModule"] = this.hasAttendanceModule;
        data["hasTasksModule"] = this.hasTasksModule;
        data["hasWealthModule"] = this.hasWealthModule;
        data["hasWarehousesModule"] = this.hasWarehousesModule;
        data["hasGanttModule"] = this.hasGanttModule;
        data["hasAIModule"] = this.hasAIModule;
        data["hasReportsModule"] = this.hasReportsModule;
        return data;
    }
}

export interface IRegisterAndChooseModulesRequestDTO {
    pendingRegistrationId?: string;
    companyName: string;
    email: string;
    phonePrefix: string;
    phoneNumber: string;
    language: string;
    source: string;
    ico?: string;
    hasDiaryModule?: boolean;
    hasAttendanceModule?: boolean;
    hasTasksModule?: boolean;
    hasWealthModule?: boolean;
    hasWarehousesModule?: boolean;
    hasGanttModule?: boolean;
    hasAIModule?: boolean;
    hasReportsModule?: boolean;

    [key: string]: any;
}

export class RegisterAndChooseModulesResponseDTO implements IRegisterAndChooseModulesResponseDTO {
    url?: string;
    key?: string;

    [key: string]: any;

    constructor(data?: IRegisterAndChooseModulesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.url = _data["url"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): RegisterAndChooseModulesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterAndChooseModulesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["url"] = this.url;
        data["key"] = this.key;
        return data;
    }
}

export interface IRegisterAndChooseModulesResponseDTO {
    url?: string;
    key?: string;

    [key: string]: any;
}

export class ActionsResponseDTO implements IActionsResponseDTO {
    type?: string;
    wage?: number;
    datetime?: string;

    [key: string]: any;

    constructor(data?: IActionsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.wage = _data["wage"];
            this.datetime = _data["datetime"];
        }
    }

    static fromJS(data: any): ActionsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ActionsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["wage"] = this.wage;
        data["datetime"] = this.datetime;
        return data;
    }
}

export interface IActionsResponseDTO {
    type?: string;
    wage?: number;
    datetime?: string;

    [key: string]: any;
}

export class AttendanceResponseDTO implements IAttendanceResponseDTO {
    /** odpracovaný čas v minutách */
    minutes?: number;
    /** poznámka */
    note?: string;
    /** upravený záznam administrátorem? */
    isAdminEdited?: boolean;
    /** částka */
    deposit?: number;
    /** zaplaceno? */
    depositIsPaid?: string;
    /** poznámka */
    depositNote?: string;
    actions?: any;

    [key: string]: any;

    constructor(data?: IAttendanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.minutes = _data["minutes"];
            this.note = _data["note"];
            this.isAdminEdited = _data["isAdminEdited"];
            this.deposit = _data["deposit"];
            this.depositIsPaid = _data["depositIsPaid"];
            this.depositNote = _data["depositNote"];
            this.actions = _data["actions"];
        }
    }

    static fromJS(data: any): AttendanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["minutes"] = this.minutes;
        data["note"] = this.note;
        data["isAdminEdited"] = this.isAdminEdited;
        data["deposit"] = this.deposit;
        data["depositIsPaid"] = this.depositIsPaid;
        data["depositNote"] = this.depositNote;
        data["actions"] = this.actions;
        return data;
    }
}

export interface IAttendanceResponseDTO {
    /** odpracovaný čas v minutách */
    minutes?: number;
    /** poznámka */
    note?: string;
    /** upravený záznam administrátorem? */
    isAdminEdited?: boolean;
    /** částka */
    deposit?: number;
    /** zaplaceno? */
    depositIsPaid?: string;
    /** poznámka */
    depositNote?: string;
    actions?: any;

    [key: string]: any;
}

export class GetAttendanceResponseDTO implements IGetAttendanceResponseDTO {
    month?: number;
    dates?: { [key: string]: AttendanceResponseDTO; };

    [key: string]: any;

    constructor(data?: IGetAttendanceResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.month = _data["month"];
            if (_data["dates"]) {
                this.dates = {} as any;
                for (let key in _data["dates"]) {
                    if (_data["dates"].hasOwnProperty(key))
                        (<any>this.dates)![key] = _data["dates"][key] ? AttendanceResponseDTO.fromJS(_data["dates"][key]) : new AttendanceResponseDTO();
                }
            }
        }
    }

    static fromJS(data: any): GetAttendanceResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAttendanceResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["month"] = this.month;
        if (this.dates) {
            data["dates"] = {};
            for (let key in this.dates) {
                if (this.dates.hasOwnProperty(key))
                    (<any>data["dates"])[key] = this.dates[key] ? this.dates[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetAttendanceResponseDTO {
    month?: number;
    dates?: { [key: string]: AttendanceResponseDTO; };

    [key: string]: any;
}

export class BozpItemResponseDTO implements IBozpItemResponseDTO {
    bozpId?: number;
    name?: string;
    isRead?: boolean;

    [key: string]: any;

    constructor(data?: IBozpItemResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.bozpId = _data["bozpId"];
            this.name = _data["name"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): BozpItemResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BozpItemResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["bozpId"] = this.bozpId;
        data["name"] = this.name;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface IBozpItemResponseDTO {
    bozpId?: number;
    name?: string;
    isRead?: boolean;

    [key: string]: any;
}

export class GetAllBozpResponseDTO implements IGetAllBozpResponseDTO {
    bozp?: { [key: string]: BozpItemResponseDTO; };

    [key: string]: any;

    constructor(data?: IGetAllBozpResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["bozp"]) {
                this.bozp = {} as any;
                for (let key in _data["bozp"]) {
                    if (_data["bozp"].hasOwnProperty(key))
                        (<any>this.bozp)![key] = _data["bozp"][key] ? BozpItemResponseDTO.fromJS(_data["bozp"][key]) : new BozpItemResponseDTO();
                }
            }
        }
    }

    static fromJS(data: any): GetAllBozpResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBozpResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.bozp) {
            data["bozp"] = {};
            for (let key in this.bozp) {
                if (this.bozp.hasOwnProperty(key))
                    (<any>data["bozp"])[key] = this.bozp[key] ? this.bozp[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetAllBozpResponseDTO {
    bozp?: { [key: string]: BozpItemResponseDTO; };

    [key: string]: any;
}

export class SetBozpAsReadRequestDTO implements ISetBozpAsReadRequestDTO {
    bozpId!: number;
    /** obrázek podpisu (base64) */
    signature!: string;

    [key: string]: any;

    constructor(data?: ISetBozpAsReadRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.bozpId = _data["bozpId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetBozpAsReadRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetBozpAsReadRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["bozpId"] = this.bozpId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetBozpAsReadRequestDTO {
    bozpId: number;
    /** obrázek podpisu (base64) */
    signature: string;

    [key: string]: any;
}

export class SetBozpAsReadResponseDTO implements ISetBozpAsReadResponseDTO {
    bozpId?: number;
    isRead?: boolean;

    [key: string]: any;

    constructor(data?: ISetBozpAsReadResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.bozpId = _data["bozpId"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): SetBozpAsReadResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetBozpAsReadResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["bozpId"] = this.bozpId;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface ISetBozpAsReadResponseDTO {
    bozpId?: number;
    isRead?: boolean;

    [key: string]: any;
}

export class PrintWholeDiaryInDateRangeRequestDTO implements IPrintWholeDiaryInDateRangeRequestDTO {
    adminUserId?: number;
    token!: string;
    diaryId?: number;
    dateFrom?: string;
    dateTo?: string;
    isOnlyNotes?: boolean;

    [key: string]: any;

    constructor(data?: IPrintWholeDiaryInDateRangeRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.adminUserId = _data["adminUserId"];
            this.token = _data["token"];
            this.diaryId = _data["diaryId"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.isOnlyNotes = _data["isOnlyNotes"];
        }
    }

    static fromJS(data: any): PrintWholeDiaryInDateRangeRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrintWholeDiaryInDateRangeRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["adminUserId"] = this.adminUserId;
        data["token"] = this.token;
        data["diaryId"] = this.diaryId;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["isOnlyNotes"] = this.isOnlyNotes;
        return data;
    }
}

export interface IPrintWholeDiaryInDateRangeRequestDTO {
    adminUserId?: number;
    token: string;
    diaryId?: number;
    dateFrom?: string;
    dateTo?: string;
    isOnlyNotes?: boolean;

    [key: string]: any;
}

export class PrintWholeDiaryInvestorRequestDTO implements IPrintWholeDiaryInvestorRequestDTO {
    token!: string;
    investorId?: number;
    diaryId?: number;
    isOnlyNotes?: boolean;

    [key: string]: any;

    constructor(data?: IPrintWholeDiaryInvestorRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.investorId = _data["investorId"];
            this.diaryId = _data["diaryId"];
            this.isOnlyNotes = _data["isOnlyNotes"];
        }
    }

    static fromJS(data: any): PrintWholeDiaryInvestorRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrintWholeDiaryInvestorRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["investorId"] = this.investorId;
        data["diaryId"] = this.diaryId;
        data["isOnlyNotes"] = this.isOnlyNotes;
        return data;
    }
}

export interface IPrintWholeDiaryInvestorRequestDTO {
    token: string;
    investorId?: number;
    diaryId?: number;
    isOnlyNotes?: boolean;

    [key: string]: any;
}

export class PrintWholeDiaryRequestDTO implements IPrintWholeDiaryRequestDTO {
    token!: string;
    adminUserId?: number;
    diaryId?: number;
    isOnlyNotes?: boolean;

    [key: string]: any;

    constructor(data?: IPrintWholeDiaryRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.diaryId = _data["diaryId"];
            this.isOnlyNotes = _data["isOnlyNotes"];
        }
    }

    static fromJS(data: any): PrintWholeDiaryRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrintWholeDiaryRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["diaryId"] = this.diaryId;
        data["isOnlyNotes"] = this.isOnlyNotes;
        return data;
    }
}

export interface IPrintWholeDiaryRequestDTO {
    token: string;
    adminUserId?: number;
    diaryId?: number;
    isOnlyNotes?: boolean;

    [key: string]: any;
}

export class PrintWholeDiaryResponseDTO implements IPrintWholeDiaryResponseDTO {
    fileUrl?: string;
    error?: string;
    ok?: boolean;

    [key: string]: any;

    constructor(data?: IPrintWholeDiaryResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fileUrl = _data["fileUrl"];
            this.error = _data["error"];
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PrintWholeDiaryResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PrintWholeDiaryResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fileUrl"] = this.fileUrl;
        data["error"] = this.error;
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPrintWholeDiaryResponseDTO {
    fileUrl?: string;
    error?: string;
    ok?: boolean;

    [key: string]: any;
}

export class AddImagesRequestDTO implements IAddImagesRequestDTO {
    buildingId!: number;
    images!: string[];

    [key: string]: any;

    constructor(data?: IAddImagesRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.images = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buildingId = _data["buildingId"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): AddImagesRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddImagesRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buildingId"] = this.buildingId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IAddImagesRequestDTO {
    buildingId: number;
    images: string[];

    [key: string]: any;
}

export class AddImagesResponseDTO implements IAddImagesResponseDTO {
    /** Počet přidaných obrázků */
    addedImages?: number;
    images?: string;

    [key: string]: any;

    constructor(data?: IAddImagesResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.addedImages = _data["addedImages"];
            this.images = _data["images"];
        }
    }

    static fromJS(data: any): AddImagesResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddImagesResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["addedImages"] = this.addedImages;
        data["images"] = this.images;
        return data;
    }
}

export interface IAddImagesResponseDTO {
    /** Počet přidaných obrázků */
    addedImages?: number;
    images?: string;

    [key: string]: any;
}

export class BuildingResponseDTO implements IBuildingResponseDTO {
    buildingId?: number;
    name?: string;
    code?: string;
    city?: string;
    admin?: boolean;
    gps_point_1?: GpsPointDTO;
    gps_point_2?: GpsPointDTO | undefined;
    gps_point_3?: GpsPointDTO | undefined;
    gps_point_4?: GpsPointDTO | undefined;

    [key: string]: any;

    constructor(data?: IBuildingResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buildingId = _data["buildingId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.city = _data["city"];
            this.admin = _data["admin"];
            this.gps_point_1 = _data["gps_point_1"] ? GpsPointDTO.fromJS(_data["gps_point_1"]) : <any>undefined;
            this.gps_point_2 = _data["gps_point_2"] ? GpsPointDTO.fromJS(_data["gps_point_2"]) : <any>undefined;
            this.gps_point_3 = _data["gps_point_3"] ? GpsPointDTO.fromJS(_data["gps_point_3"]) : <any>undefined;
            this.gps_point_4 = _data["gps_point_4"] ? GpsPointDTO.fromJS(_data["gps_point_4"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BuildingResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buildingId"] = this.buildingId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["city"] = this.city;
        data["admin"] = this.admin;
        data["gps_point_1"] = this.gps_point_1 ? this.gps_point_1.toJSON() : <any>undefined;
        data["gps_point_2"] = this.gps_point_2 ? this.gps_point_2.toJSON() : <any>undefined;
        data["gps_point_3"] = this.gps_point_3 ? this.gps_point_3.toJSON() : <any>undefined;
        data["gps_point_4"] = this.gps_point_4 ? this.gps_point_4.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBuildingResponseDTO {
    buildingId?: number;
    name?: string;
    code?: string;
    city?: string;
    admin?: boolean;
    gps_point_1?: GpsPointDTO;
    gps_point_2?: GpsPointDTO | undefined;
    gps_point_3?: GpsPointDTO | undefined;
    gps_point_4?: GpsPointDTO | undefined;

    [key: string]: any;
}

export class EmployeeDTO implements IEmployeeDTO {
    name?: string;
    code?: string;
    adminId?: number;

    [key: string]: any;

    constructor(data?: IEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.code = _data["code"];
            this.adminId = _data["adminId"];
        }
    }

    static fromJS(data: any): EmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["code"] = this.code;
        data["adminId"] = this.adminId;
        return data;
    }
}

export interface IEmployeeDTO {
    name?: string;
    code?: string;
    adminId?: number;

    [key: string]: any;
}

export class GpsPointDTO implements IGpsPointDTO {
    gps_x?: number;
    gps_y?: number;
    gps_diff?: number;

    [key: string]: any;

    constructor(data?: IGpsPointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.gps_x = _data["gps_x"];
            this.gps_y = _data["gps_y"];
            this.gps_diff = _data["gps_diff"];
        }
    }

    static fromJS(data: any): GpsPointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GpsPointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["gps_x"] = this.gps_x;
        data["gps_y"] = this.gps_y;
        data["gps_diff"] = this.gps_diff;
        return data;
    }
}

export interface IGpsPointDTO {
    gps_x?: number;
    gps_y?: number;
    gps_diff?: number;

    [key: string]: any;
}

export class ButtonResponseDTO implements IButtonResponseDTO {
    name?: string;
    type?: number;
    textColor?: string;
    backgroundColor?: string;
    disabled?: boolean;
    disabledStart?: boolean;
    disabledEnd?: boolean;

    [key: string]: any;

    constructor(data?: IButtonResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.type = _data["type"];
            this.textColor = _data["textColor"];
            this.backgroundColor = _data["backgroundColor"];
            this.disabled = _data["disabled"];
            this.disabledStart = _data["disabledStart"];
            this.disabledEnd = _data["disabledEnd"];
        }
    }

    static fromJS(data: any): ButtonResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ButtonResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["type"] = this.type;
        data["textColor"] = this.textColor;
        data["backgroundColor"] = this.backgroundColor;
        data["disabled"] = this.disabled;
        data["disabledStart"] = this.disabledStart;
        data["disabledEnd"] = this.disabledEnd;
        return data;
    }
}

export interface IButtonResponseDTO {
    name?: string;
    type?: number;
    textColor?: string;
    backgroundColor?: string;
    disabled?: boolean;
    disabledStart?: boolean;
    disabledEnd?: boolean;

    [key: string]: any;
}

export class GetBuildingRequestDTO implements IGetBuildingRequestDTO {
    token!: string;
    adminUserId?: string;
    buildingId?: string;

    [key: string]: any;

    constructor(data?: IGetBuildingRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.buildingId = _data["buildingId"];
        }
    }

    static fromJS(data: any): GetBuildingRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["buildingId"] = this.buildingId;
        return data;
    }
}

export interface IGetBuildingRequestDTO {
    token: string;
    adminUserId?: string;
    buildingId?: string;

    [key: string]: any;
}

export class GetBuildingResponseDTO implements IGetBuildingResponseDTO {
    error?: string;
    name?: string;
    assignedUsers?: string;
    active?: string;
    gps_x?: string;
    gps_y?: string;
    gps_allowed_deviation?: string;

    [key: string]: any;

    constructor(data?: IGetBuildingResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.error = _data["error"];
            this.name = _data["name"];
            this.assignedUsers = _data["assignedUsers"];
            this.active = _data["active"];
            this.gps_x = _data["gps_x"];
            this.gps_y = _data["gps_y"];
            this.gps_allowed_deviation = _data["gps_allowed_deviation"];
        }
    }

    static fromJS(data: any): GetBuildingResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetBuildingResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["error"] = this.error;
        data["name"] = this.name;
        data["assignedUsers"] = this.assignedUsers;
        data["active"] = this.active;
        data["gps_x"] = this.gps_x;
        data["gps_y"] = this.gps_y;
        data["gps_allowed_deviation"] = this.gps_allowed_deviation;
        return data;
    }
}

export interface IGetBuildingResponseDTO {
    error?: string;
    name?: string;
    assignedUsers?: string;
    active?: string;
    gps_x?: string;
    gps_y?: string;
    gps_allowed_deviation?: string;

    [key: string]: any;
}

export class GetEmployeeRequestDTO implements IGetEmployeeRequestDTO {
    token!: string;
    adminUserId?: string;
    employeeCode?: string;

    [key: string]: any;

    constructor(data?: IGetEmployeeRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.employeeCode = _data["employeeCode"];
        }
    }

    static fromJS(data: any): GetEmployeeRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["employeeCode"] = this.employeeCode;
        return data;
    }
}

export interface IGetEmployeeRequestDTO {
    token: string;
    adminUserId?: string;
    employeeCode?: string;

    [key: string]: any;
}

export class GetEmployeeResponseDTO implements IGetEmployeeResponseDTO {
    error?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
    wage?: string;
    group?: string;
    active?: string;
    lastEmployeeCode?: string;

    [key: string]: any;

    constructor(data?: IGetEmployeeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.error = _data["error"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.wage = _data["wage"];
            this.group = _data["group"];
            this.active = _data["active"];
            this.lastEmployeeCode = _data["lastEmployeeCode"];
        }
    }

    static fromJS(data: any): GetEmployeeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["error"] = this.error;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["wage"] = this.wage;
        data["group"] = this.group;
        data["active"] = this.active;
        data["lastEmployeeCode"] = this.lastEmployeeCode;
        return data;
    }
}

export interface IGetEmployeeResponseDTO {
    error?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
    wage?: string;
    group?: string;
    active?: string;
    lastEmployeeCode?: string;

    [key: string]: any;
}

export class GetRecordsRequestDTO implements IGetRecordsRequestDTO {
    token!: string;
    adminUserId?: string;
    employeeCode?: string;
    date?: string;

    [key: string]: any;

    constructor(data?: IGetRecordsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.employeeCode = _data["employeeCode"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): GetRecordsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["employeeCode"] = this.employeeCode;
        data["date"] = this.date;
        return data;
    }
}

export interface IGetRecordsRequestDTO {
    token: string;
    adminUserId?: string;
    employeeCode?: string;
    date?: string;

    [key: string]: any;
}

export class GetRecordsResponseDTO implements IGetRecordsResponseDTO {
    error?: string;
    response?: string;

    [key: string]: any;

    constructor(data?: IGetRecordsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.error = _data["error"];
            this.response = _data["response"];
        }
    }

    static fromJS(data: any): GetRecordsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["error"] = this.error;
        data["response"] = this.response;
        return data;
    }
}

export interface IGetRecordsResponseDTO {
    error?: string;
    response?: string;

    [key: string]: any;
}

export class DocumentResponseDTO implements IDocumentResponseDTO {
    documentType?: DocumentResponseDTODocumentType;
    documentId?: number;
    name?: string;
    file?: string;
    isRead?: boolean;
    isRejected?: boolean;

    [key: string]: any;

    constructor(data?: IDocumentResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.isRead = _data["isRead"];
            this.isRejected = _data["isRejected"];
        }
    }

    static fromJS(data: any): DocumentResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        data["name"] = this.name;
        data["file"] = this.file;
        data["isRead"] = this.isRead;
        data["isRejected"] = this.isRejected;
        return data;
    }
}

export interface IDocumentResponseDTO {
    documentType?: DocumentResponseDTODocumentType;
    documentId?: number;
    name?: string;
    file?: string;
    isRead?: boolean;
    isRejected?: boolean;

    [key: string]: any;
}

export class SetDocumentAsReadRequestDTO implements ISetDocumentAsReadRequestDTO {
    documentId!: number;
    documentType!: string;
    /** image (base64) */
    signature?: string;

    [key: string]: any;

    constructor(data?: ISetDocumentAsReadRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetDocumentAsReadRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsReadRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetDocumentAsReadRequestDTO {
    documentId: number;
    documentType: string;
    /** image (base64) */
    signature?: string;

    [key: string]: any;
}

export class SetDocumentAsRejectedRequestDTO implements ISetDocumentAsRejectedRequestDTO {
    documentId!: number;
    documentType!: string;

    [key: string]: any;

    constructor(data?: ISetDocumentAsRejectedRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): SetDocumentAsRejectedRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentAsRejectedRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        return data;
    }
}

export interface ISetDocumentAsRejectedRequestDTO {
    documentId: number;
    documentType: string;

    [key: string]: any;
}

export class ChangePinRequestDTO implements IChangePinRequestDTO {
    oldEmployeePin?: string;
    newEmployeePin?: string;

    [key: string]: any;

    constructor(data?: IChangePinRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.oldEmployeePin = _data["oldEmployeePin"];
            this.newEmployeePin = _data["newEmployeePin"];
        }
    }

    static fromJS(data: any): ChangePinRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePinRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["oldEmployeePin"] = this.oldEmployeePin;
        data["newEmployeePin"] = this.newEmployeePin;
        return data;
    }
}

export interface IChangePinRequestDTO {
    oldEmployeePin?: string;
    newEmployeePin?: string;

    [key: string]: any;
}

export class ChangePinResponseDTO implements IChangePinResponseDTO {
    changed?: boolean;

    [key: string]: any;

    constructor(data?: IChangePinResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): ChangePinResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePinResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["changed"] = this.changed;
        return data;
    }
}

export interface IChangePinResponseDTO {
    changed?: boolean;

    [key: string]: any;
}

export class EditWorkTimeNotifyRequestDTO implements IEditWorkTimeNotifyRequestDTO {
    employeeId?: number;
    notifyWorkTimeFrom?: string;
    notifyWorkTimeTo?: string;

    [key: string]: any;

    constructor(data?: IEditWorkTimeNotifyRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.employeeId = _data["employeeId"];
            this.notifyWorkTimeFrom = _data["notifyWorkTimeFrom"];
            this.notifyWorkTimeTo = _data["notifyWorkTimeTo"];
        }
    }

    static fromJS(data: any): EditWorkTimeNotifyRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditWorkTimeNotifyRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["employeeId"] = this.employeeId;
        data["notifyWorkTimeFrom"] = this.notifyWorkTimeFrom;
        data["notifyWorkTimeTo"] = this.notifyWorkTimeTo;
        return data;
    }
}

export interface IEditWorkTimeNotifyRequestDTO {
    employeeId?: number;
    notifyWorkTimeFrom?: string;
    notifyWorkTimeTo?: string;

    [key: string]: any;
}

export class EditWorkTimeNotifyResponseDTO implements IEditWorkTimeNotifyResponseDTO {
    changed?: boolean;

    [key: string]: any;

    constructor(data?: IEditWorkTimeNotifyResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.changed = _data["changed"];
        }
    }

    static fromJS(data: any): EditWorkTimeNotifyResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditWorkTimeNotifyResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["changed"] = this.changed;
        return data;
    }
}

export interface IEditWorkTimeNotifyResponseDTO {
    changed?: boolean;

    [key: string]: any;
}

export class EmployeeInfoResponseDTO implements IEmployeeInfoResponseDTO {
    id?: number;
    adminId?: number;
    applicationsId?: number;
    name?: string;
    code?: string;
    building_id?: number;
    takeLoginPhoto?: number;

    [key: string]: any;

    constructor(data?: IEmployeeInfoResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.adminId = _data["adminId"];
            this.applicationsId = _data["applicationsId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.building_id = _data["building_id"];
            this.takeLoginPhoto = _data["takeLoginPhoto"];
        }
    }

    static fromJS(data: any): EmployeeInfoResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInfoResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["adminId"] = this.adminId;
        data["applicationsId"] = this.applicationsId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["building_id"] = this.building_id;
        data["takeLoginPhoto"] = this.takeLoginPhoto;
        return data;
    }
}

export interface IEmployeeInfoResponseDTO {
    id?: number;
    adminId?: number;
    applicationsId?: number;
    name?: string;
    code?: string;
    building_id?: number;
    takeLoginPhoto?: number;

    [key: string]: any;
}

export class GetWorkTimeNotifyResponseDTO implements IGetWorkTimeNotifyResponseDTO {
    notifyWorkTimeFrom?: string;
    notifyWorkTimeTo?: string;

    [key: string]: any;

    constructor(data?: IGetWorkTimeNotifyResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.notifyWorkTimeFrom = _data["notifyWorkTimeFrom"];
            this.notifyWorkTimeTo = _data["notifyWorkTimeTo"];
        }
    }

    static fromJS(data: any): GetWorkTimeNotifyResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetWorkTimeNotifyResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["notifyWorkTimeFrom"] = this.notifyWorkTimeFrom;
        data["notifyWorkTimeTo"] = this.notifyWorkTimeTo;
        return data;
    }
}

export interface IGetWorkTimeNotifyResponseDTO {
    notifyWorkTimeFrom?: string;
    notifyWorkTimeTo?: string;

    [key: string]: any;
}

export class FcmTokenRequestDTO implements IFcmTokenRequestDTO {
    /** FCM Token */
    token!: string;

    [key: string]: any;

    constructor(data?: IFcmTokenRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): FcmTokenRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FcmTokenRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        return data;
    }
}

export interface IFcmTokenRequestDTO {
    /** FCM Token */
    token: string;

    [key: string]: any;
}

export class AddFileInvestorRequestDTO implements IAddFileInvestorRequestDTO {
    filename!: string;
    file!: string;
    token?: string;
    investorId?: number;
    directory?: string;
    isSignature?: boolean;

    [key: string]: any;

    constructor(data?: IAddFileInvestorRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filename = _data["filename"];
            this.file = _data["file"];
            this.token = _data["token"];
            this.investorId = _data["investorId"];
            this.directory = _data["directory"];
            this.isSignature = _data["isSignature"];
        }
    }

    static fromJS(data: any): AddFileInvestorRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileInvestorRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filename"] = this.filename;
        data["file"] = this.file;
        data["token"] = this.token;
        data["investorId"] = this.investorId;
        data["directory"] = this.directory;
        data["isSignature"] = this.isSignature;
        return data;
    }
}

export interface IAddFileInvestorRequestDTO {
    filename: string;
    file: string;
    token?: string;
    investorId?: number;
    directory?: string;
    isSignature?: boolean;

    [key: string]: any;
}

export class AddFileInvestorResponseDTO implements IAddFileInvestorResponseDTO {
    filepath?: string;
    ok?: boolean;

    [key: string]: any;

    constructor(data?: IAddFileInvestorResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filepath = _data["filepath"];
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddFileInvestorResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileInvestorResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filepath"] = this.filepath;
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddFileInvestorResponseDTO {
    filepath?: string;
    ok?: boolean;

    [key: string]: any;
}

export class AddFileRequestDTO implements IAddFileRequestDTO {
    filename!: string;
    file!: string;
    token?: string;
    adminUserId?: number;
    directory?: string;
    isSignature?: boolean;

    [key: string]: any;

    constructor(data?: IAddFileRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filename = _data["filename"];
            this.file = _data["file"];
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.directory = _data["directory"];
            this.isSignature = _data["isSignature"];
        }
    }

    static fromJS(data: any): AddFileRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filename"] = this.filename;
        data["file"] = this.file;
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["directory"] = this.directory;
        data["isSignature"] = this.isSignature;
        return data;
    }
}

export interface IAddFileRequestDTO {
    filename: string;
    file: string;
    token?: string;
    adminUserId?: number;
    directory?: string;
    isSignature?: boolean;

    [key: string]: any;
}

export class AddFileResponseDTO implements IAddFileResponseDTO {
    filepath?: string;
    ok?: boolean;

    [key: string]: any;

    constructor(data?: IAddFileResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filepath = _data["filepath"];
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AddFileResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddFileResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filepath"] = this.filepath;
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAddFileResponseDTO {
    filepath?: string;
    ok?: boolean;

    [key: string]: any;
}

export class FileMetadataResponseDTO implements IFileMetadataResponseDTO {
    filepath?: string;
    meta?: { [key: string]: string; }[];
    exif?: { [key: string]: string; }[];
    imageDbData?: { [key: string]: string; }[];
    fileDbData?: { [key: string]: string; }[];
    doesFileExist?: boolean;

    [key: string]: any;

    constructor(data?: IFileMetadataResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filepath = _data["filepath"];
            if (Array.isArray(_data["meta"])) {
                this.meta = [] as any;
                for (let item of _data["meta"])
                    this.meta!.push(item);
            }
            if (Array.isArray(_data["exif"])) {
                this.exif = [] as any;
                for (let item of _data["exif"])
                    this.exif!.push(item);
            }
            if (Array.isArray(_data["imageDbData"])) {
                this.imageDbData = [] as any;
                for (let item of _data["imageDbData"])
                    this.imageDbData!.push(item);
            }
            if (Array.isArray(_data["fileDbData"])) {
                this.fileDbData = [] as any;
                for (let item of _data["fileDbData"])
                    this.fileDbData!.push(item);
            }
            this.doesFileExist = _data["doesFileExist"];
        }
    }

    static fromJS(data: any): FileMetadataResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FileMetadataResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filepath"] = this.filepath;
        if (Array.isArray(this.meta)) {
            data["meta"] = [];
            for (let item of this.meta)
                data["meta"].push(item);
        }
        if (Array.isArray(this.exif)) {
            data["exif"] = [];
            for (let item of this.exif)
                data["exif"].push(item);
        }
        if (Array.isArray(this.imageDbData)) {
            data["imageDbData"] = [];
            for (let item of this.imageDbData)
                data["imageDbData"].push(item);
        }
        if (Array.isArray(this.fileDbData)) {
            data["fileDbData"] = [];
            for (let item of this.fileDbData)
                data["fileDbData"].push(item);
        }
        data["doesFileExist"] = this.doesFileExist;
        return data;
    }
}

export interface IFileMetadataResponseDTO {
    filepath?: string;
    meta?: { [key: string]: string; }[];
    exif?: { [key: string]: string; }[];
    imageDbData?: { [key: string]: string; }[];
    fileDbData?: { [key: string]: string; }[];
    doesFileExist?: boolean;

    [key: string]: any;
}

export class AppKeyResponseDTO implements IAppKeyResponseDTO {
    appKey?: string;
    name?: string;

    [key: string]: any;

    constructor(data?: IAppKeyResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.appKey = _data["appKey"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppKeyResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["appKey"] = this.appKey;
        data["name"] = this.name;
        return data;
    }
}

export interface IAppKeyResponseDTO {
    appKey?: string;
    name?: string;

    [key: string]: any;
}

export class LanguageRequestDTO implements ILanguageRequestDTO {
    /** Language ID (2-char) */
    language!: string;

    [key: string]: any;

    constructor(data?: ILanguageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LanguageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["language"] = this.language;
        return data;
    }
}

export interface ILanguageRequestDTO {
    /** Language ID (2-char) */
    language: string;

    [key: string]: any;
}

export class LoginRequestDTO implements ILoginRequestDTO {
    /** Application Key */
    appKey!: string;
    /** Employee Code */
    employeeCode!: string;
    /** Employee PIN */
    employeePin!: string;
    /** Firebase Cloud Messaging Registration ID */
    messagingToken?: string;
    /** Language ID (2-char) */
    language?: string;

    [key: string]: any;

    constructor(data?: ILoginRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.appKey = _data["appKey"];
            this.employeeCode = _data["employeeCode"];
            this.employeePin = _data["employeePin"];
            this.messagingToken = _data["messagingToken"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LoginRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["appKey"] = this.appKey;
        data["employeeCode"] = this.employeeCode;
        data["employeePin"] = this.employeePin;
        data["messagingToken"] = this.messagingToken;
        data["language"] = this.language;
        return data;
    }
}

export interface ILoginRequestDTO {
    /** Application Key */
    appKey: string;
    /** Employee Code */
    employeeCode: string;
    /** Employee PIN */
    employeePin: string;
    /** Firebase Cloud Messaging Registration ID */
    messagingToken?: string;
    /** Language ID (2-char) */
    language?: string;

    [key: string]: any;
}

export class LoginResponseDTO implements ILoginResponseDTO {
    token?: string;
    token_expire?: string;

    [key: string]: any;

    constructor(data?: ILoginResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.token_expire = _data["token_expire"];
        }
    }

    static fromJS(data: any): LoginResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["token_expire"] = this.token_expire;
        return data;
    }
}

export interface ILoginResponseDTO {
    token?: string;
    token_expire?: string;

    [key: string]: any;
}

export class NewRequestDTO implements INewRequestDTO {
    newId!: number;
    signature!: string;

    [key: string]: any;

    constructor(data?: INewRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.newId = _data["newId"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): NewRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["newId"] = this.newId;
        data["signature"] = this.signature;
        return data;
    }
}

export interface INewRequestDTO {
    newId: number;
    signature: string;

    [key: string]: any;
}

export class NewResponseDTO implements INewResponseDTO {
    newId?: number;
    isRead?: boolean;
    name?: string;
    file?: string;
    wealthId?: number;
    wealthDocument?: string;

    [key: string]: any;

    constructor(data?: INewResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.newId = _data["newId"];
            this.isRead = _data["isRead"];
            this.name = _data["name"];
            this.file = _data["file"];
            this.wealthId = _data["wealthId"];
            this.wealthDocument = _data["wealthDocument"];
        }
    }

    static fromJS(data: any): NewResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["newId"] = this.newId;
        data["isRead"] = this.isRead;
        data["name"] = this.name;
        data["file"] = this.file;
        data["wealthId"] = this.wealthId;
        data["wealthDocument"] = this.wealthDocument;
        return data;
    }
}

export interface INewResponseDTO {
    newId?: number;
    isRead?: boolean;
    name?: string;
    file?: string;
    wealthId?: number;
    wealthDocument?: string;

    [key: string]: any;
}

export class NewSetResponseDTO implements INewSetResponseDTO {
    newId?: number;
    isRead?: boolean;

    [key: string]: any;

    constructor(data?: INewSetResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.newId = _data["newId"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): NewSetResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewSetResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["newId"] = this.newId;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface INewSetResponseDTO {
    newId?: number;
    isRead?: boolean;

    [key: string]: any;
}

export class NewsResponseDTO implements INewsResponseDTO {
    news?: any;

    [key: string]: any;

    constructor(data?: INewsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.news = _data["news"];
        }
    }

    static fromJS(data: any): NewsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["news"] = this.news;
        return data;
    }
}

export interface INewsResponseDTO {
    news?: any;

    [key: string]: any;
}

export class OldCronRequestDTO implements IOldCronRequestDTO {
    token!: string;
    adminUserId?: number;

    [key: string]: any;

    constructor(data?: IOldCronRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
        }
    }

    static fromJS(data: any): OldCronRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OldCronRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        return data;
    }
}

export interface IOldCronRequestDTO {
    token: string;
    adminUserId?: number;

    [key: string]: any;
}

export class CreateAppFromInviteRequestDTO implements ICreateAppFromInviteRequestDTO {
    companyName!: string;
    firstname?: string;
    lastname?: string;
    email!: string;
    token?: string;
    language?: string;
    phonePrefix?: string;
    phone?: string;
    recommendationId?: number;
    source?: string;

    [key: string]: any;

    constructor(data?: ICreateAppFromInviteRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyName = _data["companyName"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.language = _data["language"];
            this.phonePrefix = _data["phonePrefix"];
            this.phone = _data["phone"];
            this.recommendationId = _data["recommendationId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): CreateAppFromInviteRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppFromInviteRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["companyName"] = this.companyName;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["email"] = this.email;
        data["token"] = this.token;
        data["language"] = this.language;
        data["phonePrefix"] = this.phonePrefix;
        data["phone"] = this.phone;
        data["recommendationId"] = this.recommendationId;
        data["source"] = this.source;
        return data;
    }
}

export interface ICreateAppFromInviteRequestDTO {
    companyName: string;
    firstname?: string;
    lastname?: string;
    email: string;
    token?: string;
    language?: string;
    phonePrefix?: string;
    phone?: string;
    recommendationId?: number;
    source?: string;

    [key: string]: any;
}

export class CreateAppFromInviteResponseDTO implements ICreateAppFromInviteResponseDTO {
    appId?: number;
    redirectUrl?: string;

    [key: string]: any;

    constructor(data?: ICreateAppFromInviteResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.appId = _data["appId"];
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): CreateAppFromInviteResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppFromInviteResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["appId"] = this.appId;
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface ICreateAppFromInviteResponseDTO {
    appId?: number;
    redirectUrl?: string;

    [key: string]: any;
}

export class GetAllRecommendationsRequestDTO implements IGetAllRecommendationsRequestDTO {
    adminUserId!: number;
    token!: string;

    [key: string]: any;

    constructor(data?: IGetAllRecommendationsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.adminUserId = _data["adminUserId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetAllRecommendationsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRecommendationsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["adminUserId"] = this.adminUserId;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetAllRecommendationsRequestDTO {
    adminUserId: number;
    token: string;

    [key: string]: any;
}

export class GetAllRecommendationsResponseDTO implements IGetAllRecommendationsResponseDTO {
    invitedCount?: number;
    createdDemoCount?: number;
    paidCount?: number;
    invitedEmails?: any[];

    [key: string]: any;

    constructor(data?: IGetAllRecommendationsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.invitedCount = _data["invitedCount"];
            this.createdDemoCount = _data["createdDemoCount"];
            this.paidCount = _data["paidCount"];
            if (Array.isArray(_data["invitedEmails"])) {
                this.invitedEmails = [] as any;
                for (let item of _data["invitedEmails"])
                    this.invitedEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllRecommendationsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRecommendationsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["invitedCount"] = this.invitedCount;
        data["createdDemoCount"] = this.createdDemoCount;
        data["paidCount"] = this.paidCount;
        if (Array.isArray(this.invitedEmails)) {
            data["invitedEmails"] = [];
            for (let item of this.invitedEmails)
                data["invitedEmails"].push(item);
        }
        return data;
    }
}

export interface IGetAllRecommendationsResponseDTO {
    invitedCount?: number;
    createdDemoCount?: number;
    paidCount?: number;
    invitedEmails?: any[];

    [key: string]: any;
}

export class GetDataForInviteRequestDTO implements IGetDataForInviteRequestDTO {
    recommendationId!: number;
    token!: string;

    [key: string]: any;

    constructor(data?: IGetDataForInviteRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.recommendationId = _data["recommendationId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): GetDataForInviteRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForInviteRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["recommendationId"] = this.recommendationId;
        data["token"] = this.token;
        return data;
    }
}

export interface IGetDataForInviteRequestDTO {
    recommendationId: number;
    token: string;

    [key: string]: any;
}

export class GetDataForInviteResponseDTO implements IGetDataForInviteResponseDTO {
    invitedPersonName?: string;
    isAppCreated?: boolean;

    [key: string]: any;

    constructor(data?: IGetDataForInviteResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.invitedPersonName = _data["invitedPersonName"];
            this.isAppCreated = _data["isAppCreated"];
        }
    }

    static fromJS(data: any): GetDataForInviteResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataForInviteResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["invitedPersonName"] = this.invitedPersonName;
        data["isAppCreated"] = this.isAppCreated;
        return data;
    }
}

export interface IGetDataForInviteResponseDTO {
    invitedPersonName?: string;
    isAppCreated?: boolean;

    [key: string]: any;
}

export class InvitedEmailDTO implements IInvitedEmailDTO {
    email?: string;
    state?: number;

    [key: string]: any;

    constructor(data?: IInvitedEmailDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): InvitedEmailDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InvitedEmailDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["state"] = this.state;
        return data;
    }
}

export interface IInvitedEmailDTO {
    email?: string;
    state?: number;

    [key: string]: any;
}

export class SendEmailToStavarioRequestDTO implements ISendEmailToStavarioRequestDTO {
    token!: string;
    adminUserId!: number;
    actionType!: number;

    [key: string]: any;

    constructor(data?: ISendEmailToStavarioRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.adminUserId = _data["adminUserId"];
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): SendEmailToStavarioRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailToStavarioRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["adminUserId"] = this.adminUserId;
        data["actionType"] = this.actionType;
        return data;
    }
}

export interface ISendEmailToStavarioRequestDTO {
    token: string;
    adminUserId: number;
    actionType: number;

    [key: string]: any;
}

export class SendEmailToStavarioResponseDTO implements ISendEmailToStavarioResponseDTO {
    message?: string;

    [key: string]: any;

    constructor(data?: ISendEmailToStavarioResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendEmailToStavarioResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailToStavarioResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }
}

export interface ISendEmailToStavarioResponseDTO {
    message?: string;

    [key: string]: any;
}

export class SendInvitationsRequestDTO implements ISendInvitationsRequestDTO {
    adminUserId!: number;
    token!: string;
    emails?: string[];
    language?: string;

    [key: string]: any;

    constructor(data?: ISendInvitationsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.adminUserId = _data["adminUserId"];
            this.token = _data["token"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): SendInvitationsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvitationsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["adminUserId"] = this.adminUserId;
        data["token"] = this.token;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["language"] = this.language;
        return data;
    }
}

export interface ISendInvitationsRequestDTO {
    adminUserId: number;
    token: string;
    emails?: string[];
    language?: string;

    [key: string]: any;
}

export class SendInvitationsResponseDTO implements ISendInvitationsResponseDTO {
    errors?: string[];

    [key: string]: any;

    constructor(data?: ISendInvitationsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): SendInvitationsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SendInvitationsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface ISendInvitationsResponseDTO {
    errors?: string[];

    [key: string]: any;
}

export class GetCustomRecordsRequestDTO implements IGetCustomRecordsRequestDTO {
    appId?: string;
    lang?: string;

    [key: string]: any;

    constructor(data?: IGetCustomRecordsRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.appId = _data["appId"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): GetCustomRecordsRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomRecordsRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["appId"] = this.appId;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IGetCustomRecordsRequestDTO {
    appId?: string;
    lang?: string;

    [key: string]: any;
}

export class GetCustomRecordsResponseDTO implements IGetCustomRecordsResponseDTO {
    customRecords?: string;

    [key: string]: any;

    constructor(data?: IGetCustomRecordsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.customRecords = _data["customRecords"];
        }
    }

    static fromJS(data: any): GetCustomRecordsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomRecordsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["customRecords"] = this.customRecords;
        return data;
    }
}

export interface IGetCustomRecordsResponseDTO {
    customRecords?: string;

    [key: string]: any;
}

export class InsertBreakRequestDTO implements IInsertBreakRequestDTO {
    type!: string;
    gpsX!: number;
    gpsY!: number;
    accuracy?: number;
    provider?: InsertBreakRequestDTOProvider;

    [key: string]: any;

    constructor(data?: IInsertBreakRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.gpsX = _data["gpsX"];
            this.gpsY = _data["gpsY"];
            this.accuracy = _data["accuracy"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): InsertBreakRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBreakRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["gpsX"] = this.gpsX;
        data["gpsY"] = this.gpsY;
        data["accuracy"] = this.accuracy;
        data["provider"] = this.provider;
        return data;
    }
}

export interface IInsertBreakRequestDTO {
    type: string;
    gpsX: number;
    gpsY: number;
    accuracy?: number;
    provider?: InsertBreakRequestDTOProvider;

    [key: string]: any;
}

export class InsertBreakResponseDTO implements IInsertBreakResponseDTO {
    buildingId?: number;
    datetime?: string;

    [key: string]: any;

    constructor(data?: IInsertBreakResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buildingId = _data["buildingId"];
            this.datetime = _data["datetime"];
        }
    }

    static fromJS(data: any): InsertBreakResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertBreakResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buildingId"] = this.buildingId;
        data["datetime"] = this.datetime;
        return data;
    }
}

export interface IInsertBreakResponseDTO {
    buildingId?: number;
    datetime?: string;

    [key: string]: any;
}

export class InsertDoctorDTO implements IInsertDoctorDTO {
    dateDoctorFrom?: string;
    dateDoctorTo?: string;
    timeDoctorFrom?: string;
    timeDoctorTo?: string;

    [key: string]: any;

    constructor(data?: IInsertDoctorDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dateDoctorFrom = _data["dateDoctorFrom"];
            this.dateDoctorTo = _data["dateDoctorTo"];
            this.timeDoctorFrom = _data["timeDoctorFrom"];
            this.timeDoctorTo = _data["timeDoctorTo"];
        }
    }

    static fromJS(data: any): InsertDoctorDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertDoctorDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dateDoctorFrom"] = this.dateDoctorFrom;
        data["dateDoctorTo"] = this.dateDoctorTo;
        data["timeDoctorFrom"] = this.timeDoctorFrom;
        data["timeDoctorTo"] = this.timeDoctorTo;
        return data;
    }
}

export interface IInsertDoctorDTO {
    dateDoctorFrom?: string;
    dateDoctorTo?: string;
    timeDoctorFrom?: string;
    timeDoctorTo?: string;

    [key: string]: any;
}

export class InsertHolidayDTO implements IInsertHolidayDTO {
    dateHolidayFrom?: string;
    dateHolidayTo?: string;
    timeHolidayFrom?: string;
    timeHolidayTo?: string;

    [key: string]: any;

    constructor(data?: IInsertHolidayDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dateHolidayFrom = _data["dateHolidayFrom"];
            this.dateHolidayTo = _data["dateHolidayTo"];
            this.timeHolidayFrom = _data["timeHolidayFrom"];
            this.timeHolidayTo = _data["timeHolidayTo"];
        }
    }

    static fromJS(data: any): InsertHolidayDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertHolidayDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dateHolidayFrom"] = this.dateHolidayFrom;
        data["dateHolidayTo"] = this.dateHolidayTo;
        data["timeHolidayFrom"] = this.timeHolidayFrom;
        data["timeHolidayTo"] = this.timeHolidayTo;
        return data;
    }
}

export interface IInsertHolidayDTO {
    dateHolidayFrom?: string;
    dateHolidayTo?: string;
    timeHolidayFrom?: string;
    timeHolidayTo?: string;

    [key: string]: any;
}

export class InsertRecordRequestDTO implements IInsertRecordRequestDTO {
    buildingId!: number;
    gpsX?: number;
    gpsY?: number;
    accuracy?: number;
    provider?: InsertRecordRequestDTOProvider;
    /** Image (base64) */
    image!: string;
    /** EXIF informations */
    metaData!: { [key: string]: string; };
    type!: string;
    deviceModel?: string;
    deviceId?: string;
    customType?: string;

    [key: string]: any;

    constructor(data?: IInsertRecordRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.metaData = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buildingId = _data["buildingId"];
            this.gpsX = _data["gpsX"];
            this.gpsY = _data["gpsY"];
            this.accuracy = _data["accuracy"];
            this.provider = _data["provider"];
            this.image = _data["image"];
            if (_data["metaData"]) {
                this.metaData = {} as any;
                for (let key in _data["metaData"]) {
                    if (_data["metaData"].hasOwnProperty(key))
                        (<any>this.metaData)![key] = _data["metaData"][key];
                }
            }
            this.type = _data["type"];
            this.deviceModel = _data["deviceModel"];
            this.deviceId = _data["deviceId"];
            this.customType = _data["customType"];
        }
    }

    static fromJS(data: any): InsertRecordRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRecordRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buildingId"] = this.buildingId;
        data["gpsX"] = this.gpsX;
        data["gpsY"] = this.gpsY;
        data["accuracy"] = this.accuracy;
        data["provider"] = this.provider;
        data["image"] = this.image;
        if (this.metaData) {
            data["metaData"] = {};
            for (let key in this.metaData) {
                if (this.metaData.hasOwnProperty(key))
                    (<any>data["metaData"])[key] = (<any>this.metaData)[key];
            }
        }
        data["type"] = this.type;
        data["deviceModel"] = this.deviceModel;
        data["deviceId"] = this.deviceId;
        data["customType"] = this.customType;
        return data;
    }
}

export interface IInsertRecordRequestDTO {
    buildingId: number;
    gpsX?: number;
    gpsY?: number;
    accuracy?: number;
    provider?: InsertRecordRequestDTOProvider;
    /** Image (base64) */
    image: string;
    /** EXIF informations */
    metaData: { [key: string]: string; };
    type: string;
    deviceModel?: string;
    deviceId?: string;
    customType?: string;

    [key: string]: any;
}

export class InsertSickDTO implements IInsertSickDTO {
    dateSickFrom?: string;
    dateSickTo?: string;
    timeSickFrom?: string;
    timeSickTo?: string;

    [key: string]: any;

    constructor(data?: IInsertSickDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dateSickFrom = _data["dateSickFrom"];
            this.dateSickTo = _data["dateSickTo"];
            this.timeSickFrom = _data["timeSickFrom"];
            this.timeSickTo = _data["timeSickTo"];
        }
    }

    static fromJS(data: any): InsertSickDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSickDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dateSickFrom"] = this.dateSickFrom;
        data["dateSickTo"] = this.dateSickTo;
        data["timeSickFrom"] = this.timeSickFrom;
        data["timeSickTo"] = this.timeSickTo;
        return data;
    }
}

export interface IInsertSickDTO {
    dateSickFrom?: string;
    dateSickTo?: string;
    timeSickFrom?: string;
    timeSickTo?: string;

    [key: string]: any;
}

export class RecordsResponseDTO implements IRecordsResponseDTO {
    action?: string;
    actionStyle?: string;
    type?: string;
    datetime?: string;
    buildingId?: number | undefined;
    buildingName?: string;

    [key: string]: any;

    constructor(data?: IRecordsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.actionStyle = _data["actionStyle"];
            this.type = _data["type"];
            this.datetime = _data["datetime"];
            this.buildingId = _data["buildingId"];
            this.buildingName = _data["buildingName"];
        }
    }

    static fromJS(data: any): RecordsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["actionStyle"] = this.actionStyle;
        data["type"] = this.type;
        data["datetime"] = this.datetime;
        data["buildingId"] = this.buildingId;
        data["buildingName"] = this.buildingName;
        return data;
    }
}

export interface IRecordsResponseDTO {
    action?: string;
    actionStyle?: string;
    type?: string;
    datetime?: string;
    buildingId?: number | undefined;
    buildingName?: string;

    [key: string]: any;
}

export class NewPinRequestDTO implements INewPinRequestDTO {
    appKey!: string;
    employeeCode!: string;

    [key: string]: any;

    constructor(data?: INewPinRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.appKey = _data["appKey"];
            this.employeeCode = _data["employeeCode"];
        }
    }

    static fromJS(data: any): NewPinRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewPinRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["appKey"] = this.appKey;
        data["employeeCode"] = this.employeeCode;
        return data;
    }
}

export interface INewPinRequestDTO {
    appKey: string;
    employeeCode: string;

    [key: string]: any;
}

export class NewPinResponseDTO implements INewPinResponseDTO {
    success?: boolean;

    [key: string]: any;

    constructor(data?: INewPinResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): NewPinResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NewPinResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        return data;
    }
}

export interface INewPinResponseDTO {
    success?: boolean;

    [key: string]: any;
}

export class AssigneeChangeResponseDTO implements IAssigneeChangeResponseDTO {
    assignee_id?: number;
    assignee_name?: string;
    change_name?: string;
    change_time?: string;
    is_admin?: boolean;

    [key: string]: any;

    constructor(data?: IAssigneeChangeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.assignee_id = _data["assignee_id"];
            this.assignee_name = _data["assignee_name"];
            this.change_name = _data["change_name"];
            this.change_time = _data["change_time"];
            this.is_admin = _data["is_admin"];
        }
    }

    static fromJS(data: any): AssigneeChangeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeChangeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["assignee_id"] = this.assignee_id;
        data["assignee_name"] = this.assignee_name;
        data["change_name"] = this.change_name;
        data["change_time"] = this.change_time;
        data["is_admin"] = this.is_admin;
        return data;
    }
}

export interface IAssigneeChangeResponseDTO {
    assignee_id?: number;
    assignee_name?: string;
    change_name?: string;
    change_time?: string;
    is_admin?: boolean;

    [key: string]: any;
}

export class AssigneeResponseDTO implements IAssigneeResponseDTO {
    id?: number;
    name?: string;

    [key: string]: any;

    constructor(data?: IAssigneeResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AssigneeResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AssigneeResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAssigneeResponseDTO {
    id?: number;
    name?: string;

    [key: string]: any;
}

export class CountDTO implements ICountDTO {
    count?: number;

    [key: string]: any;

    constructor(data?: ICountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["count"] = this.count;
        return data;
    }
}

export interface ICountDTO {
    count?: number;

    [key: string]: any;
}

export class GetMessagesDTO implements IGetMessagesDTO {
    messages?: MessageDTO[];

    [key: string]: any;

    constructor(data?: IGetMessagesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MessageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessagesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMessagesDTO {
    messages?: MessageDTO[];

    [key: string]: any;
}

export class GetRequestsResponseDTO implements IGetRequestsResponseDTO {
    requests?: RequestResponseDTO[];

    [key: string]: any;

    constructor(data?: IGetRequestsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(RequestResponseDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRequestsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetRequestsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRequestsResponseDTO {
    requests?: RequestResponseDTO[];

    [key: string]: any;
}

export class InsertMessageRequestDTO implements IInsertMessageRequestDTO {
    messageImage?: string;
    messageFile?: string;
    messageFileName?: string;
    messageText!: string;
    requestId!: number;

    [key: string]: any;

    constructor(data?: IInsertMessageRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.messageImage = _data["messageImage"];
            this.messageFile = _data["messageFile"];
            this.messageFileName = _data["messageFileName"];
            this.messageText = _data["messageText"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): InsertMessageRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMessageRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["messageImage"] = this.messageImage;
        data["messageFile"] = this.messageFile;
        data["messageFileName"] = this.messageFileName;
        data["messageText"] = this.messageText;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IInsertMessageRequestDTO {
    messageImage?: string;
    messageFile?: string;
    messageFileName?: string;
    messageText: string;
    requestId: number;

    [key: string]: any;
}

export class InsertMessageResponseDTO implements IInsertMessageResponseDTO {
    requestId!: number;
    messageFile?: string;
    messageText?: string;

    [key: string]: any;

    constructor(data?: IInsertMessageResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.messageFile = _data["messageFile"];
            this.messageText = _data["messageText"];
        }
    }

    static fromJS(data: any): InsertMessageResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertMessageResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["messageFile"] = this.messageFile;
        data["messageText"] = this.messageText;
        return data;
    }
}

export interface IInsertMessageResponseDTO {
    requestId: number;
    messageFile?: string;
    messageText?: string;

    [key: string]: any;
}

export class InsertRequestDTO implements IInsertRequestDTO {
    adminId!: number;
    buildingId?: number | undefined;
    datetimeTo?: string;
    description!: string;
    /** images (base64) */
    images?: string[];
    text!: string;
    wealthId?: number | undefined;

    [key: string]: any;

    constructor(data?: IInsertRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.adminId = _data["adminId"];
            this.buildingId = _data["buildingId"];
            this.datetimeTo = _data["datetimeTo"];
            this.description = _data["description"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.text = _data["text"];
            this.wealthId = _data["wealthId"];
        }
    }

    static fromJS(data: any): InsertRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["adminId"] = this.adminId;
        data["buildingId"] = this.buildingId;
        data["datetimeTo"] = this.datetimeTo;
        data["description"] = this.description;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["text"] = this.text;
        data["wealthId"] = this.wealthId;
        return data;
    }
}

export interface IInsertRequestDTO {
    adminId: number;
    buildingId?: number | undefined;
    datetimeTo?: string;
    description: string;
    /** images (base64) */
    images?: string[];
    text: string;
    wealthId?: number | undefined;

    [key: string]: any;
}

export class InsertRequestResponseDTO implements IInsertRequestResponseDTO {
    datetime?: string;
    datetimeTo?: string;
    buildingId?: string;
    wealthId?: string;
    text?: string;
    description?: string;

    [key: string]: any;

    constructor(data?: IInsertRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.datetime = _data["datetime"];
            this.datetimeTo = _data["datetimeTo"];
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.text = _data["text"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InsertRequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["datetime"] = this.datetime;
        data["datetimeTo"] = this.datetimeTo;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["text"] = this.text;
        data["description"] = this.description;
        return data;
    }
}

export interface IInsertRequestResponseDTO {
    datetime?: string;
    datetimeTo?: string;
    buildingId?: string;
    wealthId?: string;
    text?: string;
    description?: string;

    [key: string]: any;
}

export class MessageDTO implements IMessageDTO {
    id?: number;
    type?: string;
    senderName?: string;
    senderType?: MessageDTOSenderType;
    senderId?: number;
    messageText?: string;
    fileUrl?: string;
    imageUrl?: string;
    datetime?: string;
    read?: boolean;

    [key: string]: any;

    constructor(data?: IMessageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.senderName = _data["senderName"];
            this.senderType = _data["senderType"];
            this.senderId = _data["senderId"];
            this.messageText = _data["messageText"];
            this.fileUrl = _data["fileUrl"];
            this.imageUrl = _data["imageUrl"];
            this.datetime = _data["datetime"];
            this.read = _data["read"];
        }
    }

    static fromJS(data: any): MessageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["senderName"] = this.senderName;
        data["senderType"] = this.senderType;
        data["senderId"] = this.senderId;
        data["messageText"] = this.messageText;
        data["fileUrl"] = this.fileUrl;
        data["imageUrl"] = this.imageUrl;
        data["datetime"] = this.datetime;
        data["read"] = this.read;
        return data;
    }
}

export interface IMessageDTO {
    id?: number;
    type?: string;
    senderName?: string;
    senderType?: MessageDTOSenderType;
    senderId?: number;
    messageText?: string;
    fileUrl?: string;
    imageUrl?: string;
    datetime?: string;
    read?: boolean;

    [key: string]: any;
}

export class ModifyRequestRequestDTO implements IModifyRequestRequestDTO {
    requestId!: number;
    assignee_id?: number;
    duedate?: string;

    [key: string]: any;

    constructor(data?: IModifyRequestRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.assignee_id = _data["assignee_id"];
            this.duedate = _data["duedate"];
        }
    }

    static fromJS(data: any): ModifyRequestRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyRequestRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["assignee_id"] = this.assignee_id;
        data["duedate"] = this.duedate;
        return data;
    }
}

export interface IModifyRequestRequestDTO {
    requestId: number;
    assignee_id?: number;
    duedate?: string;

    [key: string]: any;
}

export class ModifyRequestResponseDTO implements IModifyRequestResponseDTO {
    requestId?: number;
    assignee?: AssigneeResponseDTO;
    duedate?: string;

    [key: string]: any;

    constructor(data?: IModifyRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.assignee = _data["assignee"] ? AssigneeResponseDTO.fromJS(_data["assignee"]) : <any>undefined;
            this.duedate = _data["duedate"];
        }
    }

    static fromJS(data: any): ModifyRequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyRequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["duedate"] = this.duedate;
        return data;
    }
}

export interface IModifyRequestResponseDTO {
    requestId?: number;
    assignee?: AssigneeResponseDTO;
    duedate?: string;

    [key: string]: any;
}

export class RequestResponseDTO implements IRequestResponseDTO {
    requestId?: number;
    text?: string;
    description?: string;
    datetime?: string;
    datetimeTo?: string;
    buildingId?: number;
    wealthId?: number;
    /** State of Request
0 = NEW, 1 = OPEN, 2 = DONE */
    state?: RequestResponseDTOState;
    /** Admin name */
    adminUser?: string;
    /** Creator name */
    creator?: string;
    assignee?: AssigneeResponseDTO | undefined;
    flow?: string;
    images?: string[];
    unreadMessages?: number;

    [key: string]: any;

    constructor(data?: IRequestResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.text = _data["text"];
            this.description = _data["description"];
            this.datetime = _data["datetime"];
            this.datetimeTo = _data["datetimeTo"];
            this.buildingId = _data["buildingId"];
            this.wealthId = _data["wealthId"];
            this.state = _data["state"];
            this.adminUser = _data["adminUser"];
            this.creator = _data["creator"];
            this.assignee = _data["assignee"] ? AssigneeResponseDTO.fromJS(_data["assignee"]) : <any>undefined;
            this.flow = _data["flow"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
            this.unreadMessages = _data["unreadMessages"];
        }
    }

    static fromJS(data: any): RequestResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["text"] = this.text;
        data["description"] = this.description;
        data["datetime"] = this.datetime;
        data["datetimeTo"] = this.datetimeTo;
        data["buildingId"] = this.buildingId;
        data["wealthId"] = this.wealthId;
        data["state"] = this.state;
        data["adminUser"] = this.adminUser;
        data["creator"] = this.creator;
        data["assignee"] = this.assignee ? this.assignee.toJSON() : <any>undefined;
        data["flow"] = this.flow;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        data["unreadMessages"] = this.unreadMessages;
        return data;
    }
}

export interface IRequestResponseDTO {
    requestId?: number;
    text?: string;
    description?: string;
    datetime?: string;
    datetimeTo?: string;
    buildingId?: number;
    wealthId?: number;
    /** State of Request
0 = NEW, 1 = OPEN, 2 = DONE */
    state?: RequestResponseDTOState;
    /** Admin name */
    adminUser?: string;
    /** Creator name */
    creator?: string;
    assignee?: AssigneeResponseDTO | undefined;
    flow?: string;
    images?: string[];
    unreadMessages?: number;

    [key: string]: any;
}

export class SetMessagesAsReadDTO implements ISetMessagesAsReadDTO {
    datetime!: string;
    requestId!: number;

    [key: string]: any;

    constructor(data?: ISetMessagesAsReadDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.datetime = _data["datetime"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): SetMessagesAsReadDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetMessagesAsReadDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["datetime"] = this.datetime;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ISetMessagesAsReadDTO {
    datetime: string;
    requestId: number;

    [key: string]: any;
}

export class UpdateRequestStateDTO implements IUpdateRequestStateDTO {
    requestId!: number;
    state!: number;

    [key: string]: any;

    constructor(data?: IUpdateRequestStateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.requestId = _data["requestId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateRequestStateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestStateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["requestId"] = this.requestId;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateRequestStateDTO {
    requestId: number;
    state: number;

    [key: string]: any;
}

export class AddWealthRequestDTO implements IAddWealthRequestDTO {
    images?: string[];

    [key: string]: any;

    constructor(data?: IAddWealthRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(item);
            }
        }
    }

    static fromJS(data: any): AddWealthRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AddWealthRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item);
        }
        return data;
    }
}

export interface IAddWealthRequestDTO {
    images?: string[];

    [key: string]: any;
}

export class GetEmployeesLittleWealthResponseDTO implements IGetEmployeesLittleWealthResponseDTO {
    littleWealth?: { [key: string]: LittleWealthImageResponseDTO; };

    [key: string]: any;

    constructor(data?: IGetEmployeesLittleWealthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["littleWealth"]) {
                this.littleWealth = {} as any;
                for (let key in _data["littleWealth"]) {
                    if (_data["littleWealth"].hasOwnProperty(key))
                        (<any>this.littleWealth)![key] = _data["littleWealth"][key] ? LittleWealthImageResponseDTO.fromJS(_data["littleWealth"][key]) : new LittleWealthImageResponseDTO();
                }
            }
        }
    }

    static fromJS(data: any): GetEmployeesLittleWealthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesLittleWealthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.littleWealth) {
            data["littleWealth"] = {};
            for (let key in this.littleWealth) {
                if (this.littleWealth.hasOwnProperty(key))
                    (<any>data["littleWealth"])[key] = this.littleWealth[key] ? this.littleWealth[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IGetEmployeesLittleWealthResponseDTO {
    littleWealth?: { [key: string]: LittleWealthImageResponseDTO; };

    [key: string]: any;
}

export class GetWealthsResponseDTO implements IGetWealthsResponseDTO {
    wealth?: any;

    [key: string]: any;

    constructor(data?: IGetWealthsResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.wealth = _data["wealth"];
        }
    }

    static fromJS(data: any): GetWealthsResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GetWealthsResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["wealth"] = this.wealth;
        return data;
    }
}

export interface IGetWealthsResponseDTO {
    wealth?: any;

    [key: string]: any;
}

export class LittleWealthImageResponseDTO implements ILittleWealthImageResponseDTO {
    image?: string;
    file?: string;
    isRead?: boolean;

    [key: string]: any;

    constructor(data?: ILittleWealthImageResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.image = _data["image"];
            this.file = _data["file"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): LittleWealthImageResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LittleWealthImageResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["image"] = this.image;
        data["file"] = this.file;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface ILittleWealthImageResponseDTO {
    image?: string;
    file?: string;
    isRead?: boolean;

    [key: string]: any;
}

export class LittleWealthResponseDTO implements ILittleWealthResponseDTO {
    littleWealth?: { [key: string]: string; }[];

    [key: string]: any;

    constructor(data?: ILittleWealthResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["littleWealth"])) {
                this.littleWealth = [] as any;
                for (let item of _data["littleWealth"])
                    this.littleWealth!.push(item);
            }
        }
    }

    static fromJS(data: any): LittleWealthResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LittleWealthResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.littleWealth)) {
            data["littleWealth"] = [];
            for (let item of this.littleWealth)
                data["littleWealth"].push(item);
        }
        return data;
    }
}

export interface ILittleWealthResponseDTO {
    littleWealth?: { [key: string]: string; }[];

    [key: string]: any;
}

export class SetLittleWealthAsReadRequestDTO implements ISetLittleWealthAsReadRequestDTO {
    littleWealthFileName?: string;
    signature?: string;

    [key: string]: any;

    constructor(data?: ISetLittleWealthAsReadRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.littleWealthFileName = _data["littleWealthFileName"];
            this.signature = _data["signature"];
        }
    }

    static fromJS(data: any): SetLittleWealthAsReadRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetLittleWealthAsReadRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["littleWealthFileName"] = this.littleWealthFileName;
        data["signature"] = this.signature;
        return data;
    }
}

export interface ISetLittleWealthAsReadRequestDTO {
    littleWealthFileName?: string;
    signature?: string;

    [key: string]: any;
}

export class SetLittleWealthAsReadResponseDTO implements ISetLittleWealthAsReadResponseDTO {
    littleWealthFileName?: string;
    isRead?: boolean;

    [key: string]: any;

    constructor(data?: ISetLittleWealthAsReadResponseDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.littleWealthFileName = _data["littleWealthFileName"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): SetLittleWealthAsReadResponseDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SetLittleWealthAsReadResponseDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["littleWealthFileName"] = this.littleWealthFileName;
        data["isRead"] = this.isRead;
        return data;
    }
}

export interface ISetLittleWealthAsReadResponseDTO {
    littleWealthFileName?: string;
    isRead?: boolean;

    [key: string]: any;
}

export class WealthCodesDTO implements IWealthCodesDTO {
    codes?: string[];

    [key: string]: any;

    constructor(data?: IWealthCodesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(item);
            }
        }
    }

    static fromJS(data: any): WealthCodesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthCodesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item);
        }
        return data;
    }
}

export interface IWealthCodesDTO {
    codes?: string[];

    [key: string]: any;
}

export class WealthDTO implements IWealthDTO {
    wealthId?: number;
    name?: string;
    code?: string;
    serialNumber?: string;
    previewImage?: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;

    [key: string]: any;

    constructor(data?: IWealthDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.wealthId = _data["wealthId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.serialNumber = _data["serialNumber"];
            this.previewImage = _data["previewImage"];
            this.rentDateOrientationFrom = _data["rentDateOrientationFrom"];
            this.rentDateOrientationTo = _data["rentDateOrientationTo"];
        }
    }

    static fromJS(data: any): WealthDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["wealthId"] = this.wealthId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["serialNumber"] = this.serialNumber;
        data["previewImage"] = this.previewImage;
        data["rentDateOrientationFrom"] = this.rentDateOrientationFrom;
        data["rentDateOrientationTo"] = this.rentDateOrientationTo;
        return data;
    }
}

export interface IWealthDTO {
    wealthId?: number;
    name?: string;
    code?: string;
    serialNumber?: string;
    previewImage?: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;

    [key: string]: any;
}

export class WealthUpdateRequestDTO implements IWealthUpdateRequestDTO {
    buildingId?: number | undefined;
    stockWarehouseId?: number | undefined;
    wealthCodes!: number[];
    signature!: string;
    image!: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;

    [key: string]: any;

    constructor(data?: IWealthUpdateRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.wealthCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.buildingId = _data["buildingId"];
            this.stockWarehouseId = _data["stockWarehouseId"];
            if (Array.isArray(_data["wealthCodes"])) {
                this.wealthCodes = [] as any;
                for (let item of _data["wealthCodes"])
                    this.wealthCodes!.push(item);
            }
            this.signature = _data["signature"];
            this.image = _data["image"];
            this.rentDateOrientationFrom = _data["rentDateOrientationFrom"];
            this.rentDateOrientationTo = _data["rentDateOrientationTo"];
        }
    }

    static fromJS(data: any): WealthUpdateRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WealthUpdateRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["buildingId"] = this.buildingId;
        data["stockWarehouseId"] = this.stockWarehouseId;
        if (Array.isArray(this.wealthCodes)) {
            data["wealthCodes"] = [];
            for (let item of this.wealthCodes)
                data["wealthCodes"].push(item);
        }
        data["signature"] = this.signature;
        data["image"] = this.image;
        data["rentDateOrientationFrom"] = this.rentDateOrientationFrom;
        data["rentDateOrientationTo"] = this.rentDateOrientationTo;
        return data;
    }
}

export interface IWealthUpdateRequestDTO {
    buildingId?: number | undefined;
    stockWarehouseId?: number | undefined;
    wealthCodes: number[];
    signature: string;
    image: string;
    rentDateOrientationFrom?: string;
    rentDateOrientationTo?: string;

    [key: string]: any;
}

export class AdvantoEmployeeDTO implements IAdvantoEmployeeDTO {
    id?: number;
    firstname?: string;
    lastname?: string;
    national_id?: string;
    bank_account_number?: string;
    email?: string;
    phone_number?: string;
    hourly_wage?: number;
    address_street?: string;
    address_city?: string;
    address_country?: string;
    address_zip?: string;

    [key: string]: any;

    constructor(data?: IAdvantoEmployeeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.national_id = _data["national_id"];
            this.bank_account_number = _data["bank_account_number"];
            this.email = _data["email"];
            this.phone_number = _data["phone_number"];
            this.hourly_wage = _data["hourly_wage"];
            this.address_street = _data["address_street"];
            this.address_city = _data["address_city"];
            this.address_country = _data["address_country"];
            this.address_zip = _data["address_zip"];
        }
    }

    static fromJS(data: any): AdvantoEmployeeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvantoEmployeeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["national_id"] = this.national_id;
        data["bank_account_number"] = this.bank_account_number;
        data["email"] = this.email;
        data["phone_number"] = this.phone_number;
        data["hourly_wage"] = this.hourly_wage;
        data["address_street"] = this.address_street;
        data["address_city"] = this.address_city;
        data["address_country"] = this.address_country;
        data["address_zip"] = this.address_zip;
        return data;
    }
}

export interface IAdvantoEmployeeDTO {
    id?: number;
    firstname?: string;
    lastname?: string;
    national_id?: string;
    bank_account_number?: string;
    email?: string;
    phone_number?: string;
    hourly_wage?: number;
    address_street?: string;
    address_city?: string;
    address_country?: string;
    address_zip?: string;

    [key: string]: any;
}

export class AdvantoShiftsDTO implements IAdvantoShiftsDTO {
    id?: number;
    date?: any;
    hours?: number;
    wage?: number;

    [key: string]: any;

    constructor(data?: IAdvantoShiftsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.date = _data["date"];
            this.hours = _data["hours"];
            this.wage = _data["wage"];
        }
    }

    static fromJS(data: any): AdvantoShiftsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AdvantoShiftsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["date"] = this.date;
        data["hours"] = this.hours;
        data["wage"] = this.wage;
        return data;
    }
}

export interface IAdvantoShiftsDTO {
    id?: number;
    date?: any;
    hours?: number;
    wage?: number;

    [key: string]: any;
}

export enum Order {
    N = "N",
    O = "O",
}

export enum AdvantoStatusResponseDTOCompany {
    Waiting = "waiting",
    Available = "available",
}

export enum AdvantoStatusResponseDTOEmployee {
    Waiting = "waiting",
    Available = "available",
}

export enum DocumentResponseDTODocumentType {
    Document = "document",
    DocumentTemplate = "documentTemplate",
}

export enum InsertBreakRequestDTOProvider {
    Fused = "fused",
    Gps = "gps",
    Network = "network",
    Passive = "passive",
}

export enum InsertRecordRequestDTOProvider {
    Fused = "fused",
    Gps = "gps",
    Network = "network",
    Passive = "passive",
}

export enum MessageDTOSenderType {
    Admin = "admin",
    Investor = "investor",
    Employee = "employee",
}

export enum RequestResponseDTOState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}